import { useLenderOfferAmendment } from "../../components/AmendLenderOfferButton";
import {
  PROPERTY_LOAN_PROCESSING_FEE_LABEL,
  propertyLoanProcessingFee,
  propertyLoanNetDisbursement,
} from "../../utils/propertyLoanProcessingFee";
import { isRepaymentSettled, repaymentStatusLabel, getRepaymentStatus } from "../../utils/repaymentStatus";
import { propertyLoanMonths, propertyLoanMonthlyRate } from "../../utils/propertyLoanProducts";
import { getPersonData } from "../../utils/myinfoData";
import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import React, { useState, useEffect, useMemo } from "react";
import { mockDataTeam } from "../../data/mockData";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header";
import { Progress, Avatar, Button, Upload, message } from "antd";
import Cookies from "js-cookie";
import { useHistory, useLocation } from "react-router-dom";
import { matchesLoanCardName } from "../../utils/loanCardSearch";
import { UserOutlined, UploadOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { format } from "date-fns";
import defaultIcon from "../../assets/img/Profile.png";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFDownloadLink,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../../assets/img/SL-01.png";
import boldFont from "../../assets/font/Poppins-SemiBold.ttf";
import { CircularProgress } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import parse, { domToReact } from "html-react-parser";
import italicFont from "../../assets/font/Poppins-Italic.ttf";
import LenderBorrowerProfileModal from "../../components/LenderBorrowerProfileModal";

Font.register({
  family: "Poppins",
  fonts: [
    { src: boldFont, fontWeight: "bold" }, // Bold (700)
    { src: boldFont, fontWeight: 700 }, // Bold (700)
    { src: italicFont, fontStyle: "italic" }, // Bold (700)
  ],
});

const props = {
  action: "https://smart-lend.com/accepted-loans",
  onChange({ file, fileList }) {
    if (file.status !== "uploading") {
      console.log(file, fileList);
    }
  },
};

const API_BASE_URL = "https://www.smart-lend.com/api";

const getInitials = (name) => {
  const textToSplit = name.split(" ");
  const initials =
    textToSplit?.[0]?.[0].toUpperCase() +
    (textToSplit?.[1]?.[0].toUpperCase() || "");
  return initials;
};

const parseMaybeJson = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const getNameFromIdentityPayloads = (payloads = []) => {
  for (const payload of payloads) {
    const parsed = parseMaybeJson(payload);
    const name =
      parsed?.name?.value ||
      getPersonData(parsed)?.name?.value ||
      parsed?.entity?.["basic-profile"]?.["entity-name"]?.value;

    if (name) return name;
  }

  return null;
};

const ContainerActivity2 = ({ noData }) => (
  <div
    style={{
      width: "100%",
      textAlign: "left",
      marginBottom: "12.5px",
      border: "1px solid none",
      borderRadius: "20px",
      backgroundColor: "#FFFFFFB3",
      height: "60px",
    }}
  >
    <p
      style={{
        fontFamily: "Poppins, sans-serif",
        fontWeight: "600",
        fontSize: "16px",
        color: "#142C44CC",
        textAlign: "center",
        paddingTop: "15px",
      }}
    >
      {noData}
    </p>
  </div>
);

const AcceptedLoans = () => {
  const location = useLocation();
  const pageSearch = new URLSearchParams(location.search).get("search") || "";
  const theme = useTheme();
  const [documentModalIsOpen, setDocumentModalIsOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [documentIsLoading, setDocumentIsLoading] = useState(false);
  const [documentSelected, setDocumentSelected] = useState(null);
  const [documentDataConfirmed, setDocumentDataConfirmed] = useState(false);
  const colors = tokens(theme.palette.mode);
  const [sortBy, setSortBy] = useState("default");
  const [sortBy1, setSortBy1] = useState("all");
  const [activeLoanTypeFilter, setActiveLoanTypeFilter] = useState("all");
  const [data, setData] = useState([]);
  const { renderAmendOfferButton, amendmentModal } = useLenderOfferAmendment();
  const [dataActivityLog, setActivityLog] = useState([]);
  const [personalAcceptedOffers, setPersonalAcceptedOffers] = useState([]);
  const [propertyAcceptedOffers, setPropertyAcceptedOffers] = useState([]);
  const loanTypeCounts = useMemo(
    () => ({
      all:
        data.length +
        personalAcceptedOffers.length +
        propertyAcceptedOffers.length,
      corporate: data.length + propertyAcceptedOffers.length,
      personal: personalAcceptedOffers.length,
      property: propertyAcceptedOffers.length,
      concierge: 0,
    }),
    [data, personalAcceptedOffers, propertyAcceptedOffers],
  );
  const history = useHistory();
  const [fileList, setFileList] = useState([]);
  const [screenWidth, setScreenWidth] = useState(() => window.innerWidth);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 1200
  );
  useEffect(() => {
    if (screenWidth <= 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileUploading, setFileUploading] = useState(false);
  const [confirmAgreementModal, setConfirmAgreementModal] = useState(false);
  const [somethingWrong, setSomethingWrong] = useState(false);
  const [messageForBorrower, setMessageForBorrower] = useState("");
  const [liveModalAgreementId, setLiveModalAgreementId] = useState("");
  const [activeLoanId, setActiveLoanId] = useState(null);
  const [hoveringLoanId, setHoveringLoanId] = useState(null);
  const [dateForDisbursement, setDateForDisbursement] = useState("");
  const [personalDisbursementModal, setPersonalDisbursementModal] =
    useState(false);
  const [personalDisbursementDate, setPersonalDisbursementDate] = useState("");
  const [personalDisbursementOffer, setPersonalDisbursementOffer] =
    useState(null);
  const [personalDisbursementBusy, setPersonalDisbursementBusy] =
    useState(false);
  const [personalScheduleModal, setPersonalScheduleModal] = useState(false);
  const [personalScheduleOffer, setPersonalScheduleOffer] = useState(null);
  const [personalScheduleBusy, setPersonalScheduleBusy] = useState(false);
  const [propertyDisbursementModal, setPropertyDisbursementModal] =
    useState(false);
  const [propertyDisbursementDate, setPropertyDisbursementDate] =
    useState("");
  const [propertyDisbursementOffer, setPropertyDisbursementOffer] =
    useState(null);
  const [propertyDisbursementBusy, setPropertyDisbursementBusy] =
    useState(false);
  const [propertyScheduleModal, setPropertyScheduleModal] = useState(false);
  const [propertyScheduleOffer, setPropertyScheduleOffer] = useState(null);
  const [propertyScheduleBusy, setPropertyScheduleBusy] = useState(false);
  const [corporateScheduleModal, setCorporateScheduleModal] = useState(false);
  const [corporateScheduleLoan, setCorporateScheduleLoan] = useState(null);
  const [corporateScheduleBusy, setCorporateScheduleBusy] = useState(false);

  const styles = StyleSheet.create({
    tableContainer: {
      marginBottom: 10,
      fontSize: 8,
      borderWidth: 1,
      borderColor: "#dddddd",
    },
    tableRow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderBottomColor: "#dddddd",
      paddingBottom: 4,
      paddingTop: 4,
      fontSize: 8,
    },
    tableHeader: {
      fontFamily: "Poppins",
      fontWeight: "bold",
      fontSize: 8,
    },
    tableCol: {
      width: "50%",
      textAlign: "left",
      paddingLeft: 5,
      fontSize: 8,
    },
  });

  const PaymentScheduleTable = ({ schedule }) => (
    <View style={styles.tableContainer}>
      {/* Table Header */}
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={styles.tableCol}>Payment Date</Text>
        <Text style={styles.tableCol}>
          Principal (Rounded to the nearest dollar)
        </Text>
        <Text style={styles.tableCol}>Interest</Text>
        <Text style={styles.tableCol}>Total Amount due</Text>
      </View>
      {/* Table Rows */}
      {schedule.map((item, index) => (
        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: schedule.length - 1 === index ? 0 : 1,
            borderBottomColor: "#dddddd",
            paddingBottom: 4,
            paddingTop: 4,
          }}
          key={index}
        >
          <Text style={styles.tableCol}>{item.repay_due_date}</Text>
          <Text style={styles.tableCol}>{item.principal}</Text>
          <Text style={styles.tableCol}>{item.interest}</Text>
          <Text style={styles.tableCol}>{item.repay_amount}</Text>
        </View>
      ))}
    </View>
  );

  const getFormattedDate = () => {
    const today = new Date();

    // Format: DD-MM-YYYY
    const format1 = today
      .toLocaleDateString("en-GB")
      .split("/")
      .reverse()
      .join("-");

    // Format: DD Month YYYY
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const format2 = today.toLocaleDateString("en-GB", options);

    return `${format1}, ${format2}`;
  };
  const [typeOfDocumentVariables, setTypeOfDocumentVariables] = useState({
    loanAgreement: [
      {
        name: "Borrower",
        sub: [
          { name: "Name", sample: "Alexander Anderson" },
          { name: "NRIC", sample: "SA12345678" },
          {
            name: "Registered Address",
            sample: "123, Sample Borrower Address Street 123, Singapore.",
          },
        ],
      },
      {
        name: "Keyman",
        sub: [
          { name: "Name", sample: "James Aspen" },
          { name: "NRIC", sample: "SA12345678" },
          {
            name: "Registered Address",
            sample: "123, Sample Keyman Address Street 123, Singapore.",
          },
        ],
      },
      {
        name: "Guarantor/Custom User",
        sub: [
          { name: "Name", sample: "Custom User Name" },
          { name: "NRIC", sample: "Custom User NRIC" },
          {
            name: "Registered Address",
            sample: "Custom User Address",
          },
        ],
      },
      {
        name: "Entity Details",
        sub: [
          { name: "UEN Number", sample: "A12345678D" },
          { name: "Company Name", sample: "Incorporated Pte. Ltd." },
          {
            name: "Nature of Business",
            sample: "Manufacturing of retail sample goods",
          },
          {
            name: "Registered Address",
            sample: "123, Sample Company Address Street 123, Singapore.",
          },
        ],
      },
      { name: "Loan Amount", sample: "SGD 30,000.00" },
      { name: "Disbursement Amount", sample: "SGD 28,500.00" },
      { name: "Interest Rate", sample: "3.5%" },
      { name: "Total Interest Payable", sample: "SGD 6,300.00" },
      { name: "Principal Amount", sample: "SGD 36,300.00" },
      { name: "Loan Tenor", sample: "6 Months" },
      { name: "Monthly Installment", sample: "SGD 6,050.00" },
      { name: "Processing Fee", sample: "5.0%" },
      { name: "Processing Fee Amount", sample: "SGD 1,500.00" },
      {
        name: "Payment Schedule Table",
        sample: [
          {
            repay_amount: "SGD 6,050.00",
            interest: "SGD 1,050.00",
            principal: "SGD 5,000.00",
            repay_due_date: "2024-10-04",
          },
          {
            repay_amount: "SGD 6,050.00",
            interest: "SGD 1,050.00",
            principal: "SGD 5,000.00",
            repay_due_date: "2024-11-04",
          },
          {
            repay_amount: "SGD 6,050.00",
            interest: "SGD 1,050.00",
            principal: "SGD 5,000.00",
            repay_due_date: "2024-12-04",
          },
          {
            repay_amount: "SGD 6,050.00",
            interest: "SGD 1,050.00",
            principal: "SGD 5,000.00",
            repay_due_date: "2025-01-04",
          },
          {
            repay_amount: "SGD 6,050.00",
            interest: "SGD 1,050.00",
            principal: "SGD 5,000.00",
            repay_due_date: "2025-02-04",
          },
          {
            repay_amount: "SGD 6,050.00",
            interest: "SGD 1,050.00",
            principal: "SGD 5,000.00",
            repay_due_date: "2025-03-04",
          },
        ],
      },
      { name: "Document Generate Date", sample: getFormattedDate() },
    ],
  });
  const [variablesUsed, setVariablesUsed] = useState([]);

  const handleVariableChange = (variableName, newValue) => {
    setTypeOfDocumentVariables((prevVariables) => {
      const updatedLoanAgreement = prevVariables.loanAgreement.map(
        (variable) => {
          if (variableName.includes(".")) {
            // Handle sub-variable case (e.g., Borrower.Name)
            const [mainVar, subVar] = variableName
              .replace(/{{|}}/g, "")
              .split(".");

            if (variable.name === mainVar && variable.sub) {
              return {
                ...variable,
                sub: variable.sub.map((subVariable) =>
                  subVariable.name === subVar
                    ? { ...subVariable, sample: newValue }
                    : subVariable
                ),
              };
            }
          } else {
            // Handle top-level variable case (e.g., Loan Amount)
            if (variable.name === variableName.replace(/{{|}}/g, "")) {
              return { ...variable, sample: newValue };
            }
          }
          return variable;
        }
      );

      return { ...prevVariables, loanAgreement: updatedLoanAgreement };
    });

    const variableIndex = variablesUsed.findIndex(
      (dat) => dat.variableName === variableName
    );
    if (variableIndex > -1) {
      const updatingVariables = [...variablesUsed];
      updatingVariables[variableIndex].variableData = newValue;
      setVariablesUsed(updatingVariables);
    }
  };

  const replaceVariables = (htmlString) => {
    typeOfDocumentVariables.loanAgreement.forEach((variable) => {
      // Handle the "Payment Schedule Table" separately
      if (variable.name === "Payment Schedule Table") {
        const variablePattern = new RegExp(`{{\\s*${variable.name}\\s*}}`, "g");
        htmlString = htmlString.replace(
          variablePattern,
          `<div class="payment-schedule"></div>`
        );
      } else if (variable.sub) {
        // If the variable has sub-variables
        variable.sub.forEach((subVariable) => {
          const subVariablePattern = new RegExp(
            `{{\\s*${variable.name}\\.${subVariable.name}\\s*}}`,
            "g"
          );
          htmlString = htmlString.replace(
            subVariablePattern,
            subVariable.sample
          );
        });
      } else {
        // Handle variables without sub-variables
        const variablePattern = new RegExp(`{{\\s*${variable.name}\\s*}}`, "g");
        htmlString = htmlString.replace(variablePattern, variable.sample);
      }
    });

    return htmlString;
  };

  const findVariables = (htmlString) => {
    console.log(htmlString);
    const dataUpdated = [];

    typeOfDocumentVariables.loanAgreement.forEach((variable) => {
      if (variable.name === "Payment Schedule Table") {
        // Skip or handle separately if needed
      } else if (variable.sub) {
        // If the variable has sub-variables, check for each one
        variable.sub.forEach((subVariable) => {
          const subVariablePattern = new RegExp(
            `{{\\s*${variable.name}\\.${subVariable.name}\\s*}}`,
            "g"
          );

          if (subVariablePattern.test(htmlString)) {
            dataUpdated.push({
              variableName: `${variable.name}.${subVariable.name}`,
              variableData: subVariable.sample,
            });
          }
        });
      } else {
        // Handle variables without sub-variables
        const variablePattern = new RegExp(`{{\\s*${variable.name}\\s*}}`, "g");

        if (variablePattern.test(htmlString)) {
          dataUpdated.push({
            variableName: `${variable.name}`,
            variableData: variable.sample,
          });
        }
      }
    });

    setVariablesUsed(dataUpdated);
    return htmlString;
  };

  const handleFileSelect = (event, loanId) => {
    const file = event.target.files[0]; // Get the first selected file
    setFileUploading(true);

    if (file) {
      // Create a FormData object
      const formData = new FormData();
      formData.append("loan_id", loanId); // Replace loan_id with your actual loan ID
      formData.append("agreement", file);

      // Send a POST request with FormData
      fetch(`${API_BASE_URL}/agreement/uploadAgreement`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status.ok) {
          } else if (data.status === 400) {
            message.error(data.message);
          }
        })
        .catch((error) => {
          console.error("Error uploading agreement file:", error);
        });
      console.log(data);
      message.success("Agreement uploaded");
      const changingData = [...data];
      const dataIndex = data.findIndex((loan) => loan.loan_id === loanId);
      changingData[dataIndex].document = 1;
      setData(changingData);
      setFileUploading(false);
    }
  };

  const handleFileSelectSlip = async (event, loanId, title) => {
    const file = event.target.files[0]; // Get the first selected file
    setFileUploading(true);

    if (file) {
      // Create a FormData object
      const formData = new FormData();
      formData.append("loan_id", loanId); // Replace loan_id with your actual loan ID
      formData.append("receipt", file);

      // Send a POST request with FormData
      fetch(`${API_BASE_URL}/loan/uploadPaymentReceipt`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
          } else if (data.status === 400) {
            message.error(data.message);
          }
        })
        .catch((error) => {
          console.error("Error uploading agreement file:", error);
        });
      console.log(data);
      message.success("Loan disbursement updated");
      const changingData = [...data];
      const dataIndex = data.findIndex((loan) => loan.loan_id === loanId);
      changingData[dataIndex].receipt = 1;
      setData(changingData);
      setFileUploading(false);
    }
    try {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1 and pad with leading zero if needed
      const day = String(currentDate.getDate()).padStart(2, "0"); // Pad with leading zero if needed
      const loan_receive = `${year}-${month}-${day}`;
      const response = await fetch(
        `${API_BASE_URL}/loan/createRepay`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            loan_id: loanId,
            loan_receive: loan_receive,
          }),
        }
      );

      if (response.status === 200) {
        console.log("Loan repayment generated");
        console.log(data);
        message.success("Repayment schedule generated for borrower");
        const changingData = [...data];
        const dataIndex = data.findIndex((loan) => loan.loan_id === loanId);
        changingData[dataIndex].status = "ongoing";
        setData(changingData);
        message.success(`Loan ${loanId} status has been updated to ongoing`);
        message.success(`Borrower ${title} has been updated.`);
      }
    } catch (error) {
      console.error("Error fetching receipt:", error);
    }
  };

  // Function to handle file upload
  const handleFileUpload = () => {
    // You can use the selectedFile state variable for further processing or API requests
    if (selectedFile) {
      console.log("Selected file:", selectedFile);
      // Perform your API request here
    } else {
      console.log("No file selected.");
    }
  };

  const agreeToAgreement = async () => {
    console.log("set Agree to agreement", liveModalAgreementId);
    try {
      const response = await fetch(
        `${API_BASE_URL}/loan/updateBorrowerSignv2`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            loan_id: liveModalAgreementId,
            borrower_sign: 1,
            date_of_disbursement: dateForDisbursement,
          }),
        }
      );

      if (response.status === 200) {
        console.log("borrowerAgreement marked as signed");
        const signedAgreementIndex = data.findIndex(
          (loan) => loan.loan_id === liveModalAgreementId
        );
        const changingData = [...data];
        changingData[signedAgreementIndex].borrower_sign = true;
        changingData[signedAgreementIndex].receipt = 1;
        setData(changingData);

        try {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1 and pad with leading zero if needed
          const day = String(currentDate.getDate()).padStart(2, "0"); // Pad with leading zero if needed
          const loan_receive = `${year}-${month}-${day}`;
          const response = await fetch(
            `${API_BASE_URL}/loan/createRepay`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("token")}`,
              },
              body: JSON.stringify({
                loan_id: liveModalAgreementId,
                loan_receive: loan_receive,
              }),
            }
          );

          if (response.status === 200) {
            console.log("Loan repayment generated");
            console.log(data);
            message.success("Repayment schedule generated for borrower");
            const changingData = [...data];
            const dataIndex = data.findIndex(
              (loan) => loan.loan_id === liveModalAgreementId
            );
            changingData[dataIndex].status = "ongoing";
            setData(changingData);
            message.success(
              `Loan ${liveModalAgreementId} status has been updated to ongoing`
            );
            message.success(`Borrower has been updated.`);
            setConfirmAgreementModal(false);
            setSomethingWrong(false);
            setMessageForBorrower("");
            setLiveModalAgreementId("");
          }
        } catch (error) {
          console.error("Error fetching receipt:", error);
        }
      }
    } catch (error) {
      console.error("Error fetching loan agreement:", error);
    }
  };

  const openPersonalDisbursementModal = (offer) => {
    setPersonalDisbursementOffer(offer);
    setPersonalDisbursementDate("");
    setPersonalDisbursementModal(true);
  };

  const closePersonalDisbursementModal = () => {
    setPersonalDisbursementModal(false);
    setPersonalDisbursementOffer(null);
    setPersonalDisbursementDate("");
  };

  const submitPersonalDisbursementDate = async () => {
    if (!personalDisbursementOffer || !personalDisbursementDate) {
      return;
    }
    try {
      setPersonalDisbursementBusy(true);
      const response = await fetch(
        `${API_BASE_URL}/personalLoans/offers/${personalDisbursementOffer.id}/disbursement`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            disbursement_date: personalDisbursementDate,
          }),
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to schedule disbursement.");
      }

      message.success("Disbursement date set.");
      setPersonalAcceptedOffers((prev) =>
        prev.map((item) =>
          item.id === personalDisbursementOffer.id
            ? { ...item, ...json.offer }
            : item
        )
      );
      closePersonalDisbursementModal();
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to schedule disbursement.");
    } finally {
      setPersonalDisbursementBusy(false);
    }
  };

  const openPersonalScheduleModal = (offer) => {
    setPersonalScheduleOffer(offer);
    setPersonalScheduleModal(true);
  };

  const closePersonalScheduleModal = () => {
    setPersonalScheduleOffer(null);
    setPersonalScheduleModal(false);
  };

  const togglePersonalRepaymentStatus = async (repayment) => {
    if (!repayment?.id) return;
    try {
      setPersonalScheduleBusy(true);
      const response = await fetch(
        `${API_BASE_URL}/personalLoans/repayments/${repayment.id}/toggle-paid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ paid: repayment.status !== "paid" }),
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to update repayment status.");
      }

      const updated = json.repayment || {};
      setPersonalAcceptedOffers((prev) =>
        prev.map((offer) => {
          if (offer.id !== personalScheduleOffer?.id) return offer;
          const updatedSchedules = (offer.repayment_schedules || []).map(
            (schedule) =>
              schedule.id === updated.id ? { ...schedule, ...updated } : schedule
          );
          return { ...offer, repayment_schedules: updatedSchedules };
        })
      );
      setPersonalScheduleOffer((prev) => {
        if (!prev) return prev;
        const updatedSchedules = (prev.repayment_schedules || []).map(
          (schedule) =>
            schedule.id === updated.id ? { ...schedule, ...updated } : schedule
        );
        return { ...prev, repayment_schedules: updatedSchedules };
      });
      message.success("Repayment status updated.");
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to update repayment status.");
    } finally {
      setPersonalScheduleBusy(false);
    }
  };

  const openPropertyDisbursementModal = (offer) => {
    setPropertyDisbursementOffer(offer);
    setPropertyDisbursementDate("");
    setPropertyDisbursementModal(true);
  };

  const closePropertyDisbursementModal = () => {
    setPropertyDisbursementModal(false);
    setPropertyDisbursementOffer(null);
    setPropertyDisbursementDate("");
  };

  const submitPropertyDisbursementDate = async () => {
    if (!propertyDisbursementOffer || !propertyDisbursementDate) {
      return;
    }
    try {
      setPropertyDisbursementBusy(true);
      const response = await fetch(
        `${API_BASE_URL}/propTermLoan/offers/${propertyDisbursementOffer.id}/disbursement`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            disbursement_date: propertyDisbursementDate,
          }),
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to schedule disbursement.");
      }

      const updatedOffer = json.offer || {};
      setPropertyAcceptedOffers((prev) =>
        prev.map((item) =>
          item.id === propertyDisbursementOffer.id
            ? { ...item, ...updatedOffer }
            : item
        )
      );
      message.success("Disbursement date set.");
      closePropertyDisbursementModal();
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to schedule disbursement.");
    } finally {
      setPropertyDisbursementBusy(false);
    }
  };

  const openPropertyScheduleModal = (offer) => {
    setPropertyScheduleOffer(offer);
    setPropertyScheduleModal(true);
  };

  const closePropertyScheduleModal = () => {
    setPropertyScheduleOffer(null);
    setPropertyScheduleModal(false);
  };

  const togglePropertyRepaymentStatus = async (repayment) => {
    if (!repayment?.id) return;
    try {
      setPropertyScheduleBusy(true);
      const response = await fetch(
        `${API_BASE_URL}/propTermLoan/repayments/${repayment.id}/toggle-paid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ paid: repayment.status !== "paid" }),
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to update repayment status.");
      }

      const updated = json.repayment || {};
      setPropertyAcceptedOffers((prev) =>
        prev.map((offer) => {
          if (offer.id !== propertyScheduleOffer?.id) return offer;
          const updatedSchedules = (offer.repayment_schedules || []).map(
            (schedule) =>
              schedule.id === updated.id ? { ...schedule, ...updated } : schedule
          );
          return { ...offer, repayment_schedules: updatedSchedules };
        })
      );
      setPropertyScheduleOffer((prev) => {
        if (!prev) return prev;
        const updatedSchedules = (prev.repayment_schedules || []).map(
          (schedule) =>
            schedule.id === updated.id ? { ...schedule, ...updated } : schedule
        );
        return { ...prev, repayment_schedules: updatedSchedules };
      });
      message.success("Repayment status updated.");
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to update repayment status.");
    } finally {
      setPropertyScheduleBusy(false);
    }
  };

  const openCorporateScheduleModal = (loan) => {
    setCorporateScheduleLoan(loan);
    setCorporateScheduleModal(true);
  };

  const closeCorporateScheduleModal = () => {
    setCorporateScheduleLoan(null);
    setCorporateScheduleModal(false);
  };

  const toggleCorporateRepaymentStatus = async (repayment) => {
    if (!repayment?.repay_id && !repayment?.id) return;
    try {
      if (repayment.status === "done") {
        return;
      }
      setCorporateScheduleBusy(true);
      const repayId = repayment.repay_id || repayment.id;
      const lenderId = repayment.lender_id || corporateScheduleLoan?.lender_id;
      if (!repayId || !lenderId) {
        throw new Error("Missing repayment details.");
      }
      const response = await fetch(
        `${API_BASE_URL}/loan/makePayment?repay_id=${repayId}&lender_id=${lenderId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to update repayment status.");
      }

      const updated = {
        ...repayment,
        status: "done",
        repay_date: new Date().toISOString().split("T")[0],
      };
      const updatedKey = updated.repay_id || updated.id;
      setData((prev) =>
        prev.map((loan) => {
          if (loan.loan_id !== corporateScheduleLoan?.loan_id) return loan;
          const updatedRepayments = (loan.repayments || []).map((schedule) =>
            (schedule.repay_id || schedule.id) === updatedKey
              ? { ...schedule, ...updated }
              : schedule
          );
          return { ...loan, repayments: updatedRepayments };
        })
      );
      setCorporateScheduleLoan((prev) => {
        if (!prev) return prev;
        const updatedRepayments = (prev.repayments || []).map((schedule) =>
          (schedule.repay_id || schedule.id) === updatedKey
            ? { ...schedule, ...updated }
            : schedule
        );
        return { ...prev, repayments: updatedRepayments };
      });
      message.success(json?.message || "Repayment marked as received.");
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to update repayment status.");
    } finally {
      setCorporateScheduleBusy(false);
    }
  };

  const amendAgreement = async () => {
    console.log("set disagree and reverse to agreement", liveModalAgreementId);
    try {
      const response = await fetch(
        `${API_BASE_URL}/loan/updateStatusNote`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            loan_id: liveModalAgreementId,
            status_notes: messageForBorrower,
          }), // Convert the object to a JSON string
        }
      );

      if (response.status === 200) {
        console.log("borrowerAgreement marked as signed");
        const signedAgreementIndex = data.findIndex(
          (loan) => loan.loan_id === liveModalAgreementId
        );
        const changingData = [...data];
        changingData[signedAgreementIndex].borrower_uploaded_agreement = false;
        setData(changingData);
        setConfirmAgreementModal(false);
        setSomethingWrong(false);
        setMessageForBorrower("");
        setLiveModalAgreementId("");
      }
    } catch (error) {
      console.error("Error fetching loan agreement:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-"; // Return a default value if the date string is not provided

    const date = new Date(dateString); // Create a Date object from the date string
    const formattedDate = format(date, "MMM dd, yyyy"); // Use date-fns to format the date in the desired format

    return formattedDate;
  };

  const formatCurrency = (value) => {
    if (value === undefined || value === null || value === "") return "-";
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return numeric.toLocaleString("en-SG", {
      style: "currency",
      currency: "SGD",
    });
  };

  const getPersonalOfferBorrowerName = (offer) =>
    getNameFromIdentityPayloads([
      offer?.request?.myinfo_data,
      offer?.request?.borrower?.myinfo_data,
      offer?.borrower_summary?.myinfo_data,
      offer?.request?.borrower_summary?.myinfo_data,
    ]) ||
    offer?.borrower_summary?.name ||
    offer?.request?.borrower?.entity_name ||
    offer?.request?.borrower?.principal_name ||
    offer?.request?.principal_name ||
    offer?.request?.contact_email ||
    "Borrower";

  const getCompanyOfferBorrowerName = (offer) =>
    offer?.borrower_summary?.name ||
    offer?.request?.borrower_data?.entity_name ||
    offer?.request?.borrower_data?.principal_name ||
    offer?.request?.borrower?.entity_name ||
    offer?.request?.borrower?.principal_name ||
    offer?.request?.principal_name ||
    getNameFromIdentityPayloads([
      offer?.request?.borrower?.singpass_data,
      offer?.request?.borrower?.myinfo_data,
      offer?.request?.singpass_data,
      offer?.request?.myinfo_data,
    ]) ||
    "Borrower";

  const getCorporateLoanName = (loan) =>
    loan?.principal_name ||
    loan?.borrower_name ||
    loan?.borrower_details?.entity_name ||
    loan?.borrower_details?.principal_name ||
    getNameFromIdentityPayloads([
      loan?.borrower_details?.singpass_data,
      loan?.singpass_data,
    ]) ||
    "Borrower";

  const normalizePropertyLoanData = (loanData) => {
    if (!loanData) return {};
    if (typeof loanData === "string") {
      try {
        return JSON.parse(loanData);
      } catch (error) {
        return {};
      }
    }
    return loanData || {};
  };

  const getPropertyLoanTypeLabel = (loanData) => {
    const selected = Number(loanData?.selectedLoanType);
    if (selected === 0) return "First Charge Equity Term Loan";
    if (selected === 1) return "Bridging Loan";
    if (selected === 2) return "Half Caveat Loan";
    return "Property Term Loan";
  };

  const buildPropertyPreviewSchedule = (offer, disbursementDate) => {
    if (!offer || !disbursementDate) return [];
    const loanData = normalizePropertyLoanData(offer.request?.loan_data);
    const selectedLoanType = Number(loanData?.selectedLoanType || 0);
    const loanPaymentType = loanData?.loanPaymentType || "";
    const months = propertyLoanMonths(selectedLoanType, loanData);
    const amount = Number(offer.offer_data?.amount || loanData?.loanAmount || 0);
    if (!amount || !months) return [];
    const monthlyRate = propertyLoanMonthlyRate(selectedLoanType);
    const monthlyInterest = amount * monthlyRate;
    const principalPerMonth = loanPaymentType === "interest" ? 0 : amount / months;
    const startDate = new Date(disbursementDate);

    return Array.from({ length: months }, (_, index) => {
      const dueDate = new Date(startDate);
      dueDate.setMonth(dueDate.getMonth() + index + 1);
      const principalAmount =
        loanPaymentType === "interest" && index === months - 1
          ? amount
          : principalPerMonth;
      return {
        due_date: dueDate.toISOString().slice(0, 10),
        principal_amount: principalAmount,
        interest_amount: monthlyInterest,
        amount_due: principalAmount + monthlyInterest,
      };
    });
  };

  const getCorporateOutstandingAmount = (loan) => {
    const repayments = loan?.repayments || [];
    if (repayments.length > 0) {
      const outstanding = repayments
        .filter((repayment) => !isRepaymentSettled(repayment))
        .reduce(
          (total, repayment) =>
            total +
            Number(repayment.repay_total_amount ?? repayment.repay_amount ?? 0),
          0
        );
      return formatCurrency(outstanding);
    }
    return (
      ((loan.amount * (loan.interest_rate * loan.period + 1)) / loan.period) *
      (loan.period_left
        ? loan.period_left[0]
          ? loan.period_left[0].loan_period_left
            ? loan.period_left[0].loan_period_left + 1
            : loan.period
          : loan.period
        : loan.period)
    ).toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
    });
  };

  const getCorporateRemainingPeriod = (loan) => {
    const repayments = loan?.repayments || [];
    if (repayments.length > 0) {
      return repayments.filter((repayment) => !isRepaymentSettled(repayment))
        .length;
    }
    return loan.period_left.length > 0
      ? loan.period_left[0].loan_period_left
        ? loan.period_left[0].loan_period_left + 1
        : loan.period
      : loan.period;
  };

  const Container = ({
    icon,
    title,
    subtitle,
    label,
    description,
    label1,
    label2,
    description1,
    description2,
    label3,
    description3,
    label4,
    description4,
    index,
    loanId,
    borrowerId,
    lenderId,
    borrowerNotSigned,
    documentExist,
    previousDocumentExist,
    createdAt,
    remainingPeriod,
    outstandingAmount,
    item,
  }) => {
    const shouldAddMarginTop = index > 3;
    const history = useHistory();

    const viewAgreement = (loanId, event) => {
      console.log("loanId viewAgreement", loanId);
      event.preventDefault();
      history.push("/agreements", { loanId: loanId });
    };
    return (
      <>
        <div
          className="sl-rebrand-loan-card sl-pending-loan-card sl-accepted-loan-card"
          style={{
            width: "100%",
            textAlign: "center",
            borderRadius: "10px",
            backgroundColor: "#FFFFFFB3",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: screenWidth > 1200 ? "40vh" : "auto",
            padding: "15px",
            position: "relative",
            cursor: "pointer",
          }}
          onClick={(event) => {
            event.stopPropagation();
            setSelectedBorrowerProfile({ loanType: "corporate", loan: item, borrowerName: title });
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "0px",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div
                className="sl-loan-avatar"
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  background: "rgb(140,140,170)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "white",
                  fontSize: 20,
                  fontWeight: 600,
                  position: "relative",
                }}
                role="button"
                tabIndex={0}
                aria-label={`View ${title}'s profile`}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    event.currentTarget.click();
                  }
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  setSelectedBorrowerProfile({ loanType: "corporate", loan: item, borrowerName: title });
                }}
              >
                {title ? getInitials(title) : "SL"}
                {item.badge_verified ? (
                  <div
                    className="tooltip-container"
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "rgb(14, 90, 165)",
                    }}
                  >
                    <LocalPoliceIcon
                      className="tooltip-target"
                      style={{ color: "white", fontSize: "14px" }}
                    />
                    <span className="tooltip-text">
                      Verified borrowers have undergone SmartLend's
                      authentication process, demonstrating legitimate business
                      operations. This includes providing evidence such as
                      current tenancy agreements, business premises signage, or
                      recent invoices matching their bank statements
                    </span>
                  </div>
                ) : null}
              </div>
              <div
                style={{
                  marginLeft: "5px",
                  width: "calc(100% - 70px)",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "16px",
                    color: "#142C44CC",
                    textAlign: "left",
                    margin: "0px",
                  }}
                >
                  {isMobile
                    ? title.length > 23
                      ? title.slice(0, 23) + "..."
                      : title
                    : title}
                </h3>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                    textAlign: "left",
                    margin: "0px",
                  }}
                >
                  {item.badge_verified ? subtitle : null}
                </p>
              </div>
            </div>
            <div
              style={{
                textAlign: "left",
                marginTop: "20px",
              }}
            >
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "10px 0px 0px 0px",
                }}
              >
                Requested amount
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {description}
              </p>

              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Disburstment Amount
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {item.lender_id === "L66489"
                  ? parseFloat(
                      item.amount * (1 - item.processing_fee) -
                        item.monthly_installment
                    ).toLocaleString("en-US", {
                      style: "currency",
                      currency: "SGD",
                    })
                  : parseFloat(
                      item.amount * (1 - item.processing_fee)
                    ).toLocaleString("en-US", {
                      style: "currency",
                      currency: "SGD",
                    })}
              </p>

              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Processing Fee
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {parseFloat(item.amount * item.processing_fee).toLocaleString(
                  "en-US",
                  {
                    style: "currency",
                    currency: "SGD",
                  }
                )}
              </p>

              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Monthly amount
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {description1}
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Preferred rate
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {description4}
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Preferred tenor
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {description2}
              </p>

              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Remaining Period
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {remainingPeriod + 1 + " Months"}
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Outstanding Amount
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {outstandingAmount}
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Applied on
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  textAlign: "left",
                  margin: "0px 0px 10px 0px",
                }}
              >
                {formatDate(createdAt)}
              </p>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                {label3}
              </p>
            </div>
          </div>
          <div className="sl-loan-card-actions" style={{ margin: "10px 0px 0px 0px" }}>
            {renderAmendOfferButton({ loanType: "corporate", offer: item.loan_offer, loan: item, onUpdated: () => {
                setData((prev) => prev.filter((entry) => entry.id !== item.id));
              } })}
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                padding: "6px 0px",
                fontSize: "12px",
                margin: "0px",
                color: "white",
                width: "100%",
                marginTop: "10px",
                textAlign: "center",
                borderRadius: "30px",
                marginBottom: "10px",
                background:
                  description3 === "Review"
                    ? "grey"
                    : description3 === "Ongoing"
                    ? "#E7D011"
                    : description3 === "Complete"
                    ? "#139F2ACC"
                    : description3 === "Rejected"
                    ? "red"
                    : description3 === "Approved"
                    ? "0875DF"
                    : "rgba(0,0,0,0.5)",
              }}
            >
              {description3 === "Ongoing"
                ? "On-going Loan"
                : description3 === "Complete"
                ? "Completed"
                : item
                ? item.receipt
                  ? "Pending Validation"
                  : description3
                : description3}
            </p>
            {description3 !== "Ongoing" ? (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setLiveModalAgreementId(loanId);
                  setConfirmAgreementModal(true);
                }}
                className="all_button sl-card-secondary-action"
                style={{
                  background: "transparent",
                  color: "grey",
                  width: "100%",
                  border: "2px solid lightgrey",
                  borderRadius: "50px",
                  padding: "4px 0px",
                  fontSize: "12px",
                  margin: "10px 0px 0px 0px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                Approve Disbursement
              </button>
            ) : null}
            <button
              className="all_button sl-card-primary-action"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                openCorporateScheduleModal(item);
              }}
              style={{
                background: "#0E5AA5",
                color: "white",
                width: "100%",
                border: "none",
                borderRadius: "50px",
                padding: "6px 0px",
                fontSize: "12px",
                margin: "10px 0px 0px 0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              Repayment schedule
            </button>
            <button
              className="all_button sl-card-secondary-action"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                const url = `/l-messages?principelname=${item.principal_name}&userid=${item.borrower_id}&requestamount=${item.amount}`;
                history.push(url);
              }}
              style={{
                background: "transparent",
                color: "grey",
                width: "100%",
                border: "2px solid lightgrey",
                borderRadius: "15px",
                padding: "4px 20px",
                fontSize: "12px",
                marginTop: "10px",
              }}
            >
              Message borrower
            </button>
          </div>
        </div>
      </>
    );
  };

  const PersonalOfferCard = ({ offer }) => {
    const offerData = offer.offer_data || {};
    const netDisbursement = Math.max(Number(offerData.amount || 0) - Number(offerData.processing_fee || 0), 0);
    const requestedDocuments = (offerData.requested_documents || [])
      .map((doc) => (typeof doc === "string" ? doc : doc?.name))
      .filter(Boolean);
    const borrowerId =
      offer.borrower_summary?.user_id || offer.request?.user_id;
    const normalizedBorrowerId = borrowerId ? String(borrowerId) : "";
    const supportingDocs = (offer.documents || []).filter((doc) => {
      const isRequestedDoc =
        doc.stage === "supporting" ||
        doc?.metadata?.requested_document ||
        (doc?.notes && requestedDocuments.includes(doc.notes));
      if (!isRequestedDoc) return false;

      const docUserId = doc?.user_id ? String(doc.user_id) : "";
      return doc?.role === "borrower" ||
        (normalizedBorrowerId && docUserId === normalizedBorrowerId)
        ? true
        : false;
    });
    const supportingDocsByRequest = supportingDocs.reduce((acc, doc) => {
      const key =
        doc?.metadata?.requested_document || doc?.notes || "Other documents";
      if (!acc[key]) acc[key] = [];
      acc[key].push(doc);
      return acc;
    }, {});
    const repaymentSchedules = offer.repayment_schedules || [];
    const remainingPeriod =
      repaymentSchedules.length > 0
        ? repaymentSchedules.filter((schedule) => !isRepaymentSettled(schedule))
            .length
        : null;
    const outstandingAmount =
      repaymentSchedules.length > 0
        ? repaymentSchedules
            .filter((schedule) => !isRepaymentSettled(schedule))
            .reduce(
              (total, schedule) => total + Number(schedule.amount_due || 0),
              0
            )
        : null;
    const borrowerName = getPersonalOfferBorrowerName(offer);
    const statusLabel =
      offer.status === "ongoing"
        ? "Ongoing"
        : offer.status === "awaiting_lender_documents"
        ? "Accepted"
        : offer.status?.replace(/_/g, " ") || "-";

    return (
      <div
        className="sl-rebrand-loan-card sl-pending-loan-card sl-accepted-loan-card sl-personal-loan-card"
        style={{
          width: "100%",
          textAlign: "center",
          borderRadius: "10px",
          backgroundColor: "#FFFFFFB3",
          border: "1px solid rgba(214, 51, 132, 0.35)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: screenWidth > 1200 ? "40vh" : "auto",
          padding: "15px",
          position: "relative",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "0px",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              role="button"
              tabIndex={0}
              aria-label={`View ${borrowerName}'s profile`}
              onClick={(event) => {
                event.stopPropagation();
                setSelectedBorrowerProfile({ loanType: "personal", loan: { ...offer.request, borrower_summary: offer.borrower_summary }, borrowerName });
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  event.currentTarget.click();
                }
              }}
              className="sl-loan-avatar sl-loan-avatar-pink"
              style={{
                cursor: "pointer",
                width: "55px",
                height: "55px",
                borderRadius: "50%",
                background: "rgb(214, 51, 132)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                fontSize: 20,
                fontWeight: 600,
              }}
            >
              {borrowerName ? getInitials(borrowerName) : "SL"}
            </div>
            <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
              <h3
                style={{
                  fontWeight: "700",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "16px",
                  color: "#142C44CC",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                {borrowerName.length > 20
                  ? borrowerName.slice(0, 20) + "..."
                  : borrowerName}
              </h3>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(214, 51, 132, 0.7)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Personal Loan
              </p>
            </div>
          </div>

          <div style={{ textAlign: "left", marginTop: "20px" }}>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Loan Amount
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {formatCurrency(offerData.amount)}
            </p>
            {offer.adjusted_for_co_funding ? (
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(214, 51, 132, 0.8)",
                  textAlign: "left",
                  margin: "-6px 0px 10px 0px",
                }}
              >
                Adjusted due to co-funding on this loan.
              </p>
            ) : null}
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Outstanding Amount
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {outstandingAmount !== null
                ? formatCurrency(outstandingAmount)
                : "-"}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Disbursement Amount
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {formatCurrency(netDisbursement)}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Rate per month
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {offerData.rate_pa !== undefined
                ? `${offerData.rate_pa}% p.m.`
                : "-"}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Tenor
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {offerData.tenor_years
                ? `${offerData.tenor_years * 12} Months`
                : "-"}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Remaining Period
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {remainingPeriod !== null ? `${remainingPeriod} Months` : "-"}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Status
            </p>
            {offer.disbursement_date && (
              <>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                    textAlign: "left",
                    margin: "0px",
                    marginTop: "10px",
                  }}
                >
                  Disbursement Date
                </p>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "800",
                    fontSize: "16px",
                    color: "rgba(0,0,0,0.5)",
                    textAlign: "left",
                    margin: "0px 0px 10px 0px",
                  }}
                >
                  {formatDate(offer.disbursement_date)}
                </p>
              </>
            )}

            {requestedDocuments.length > 0 && (
              <div style={{ marginTop: "12px", textAlign: "left" }}>
                <div style={{ fontSize: "12px", fontWeight: 600 }}>
                  Requested documents
                </div>
                <div style={{ marginTop: "6px", fontSize: "13px" }}>
                  {requestedDocuments.map((doc) => (
                    <div key={`${offer.id}-${doc}`}>{doc}</div>
                  ))}
                </div>
              </div>
            )}

            {Object.keys(supportingDocsByRequest).length > 0 && (
              <div style={{ marginTop: "12px", textAlign: "left" }}>
                <div style={{ fontSize: "12px", fontWeight: 600 }}>
                  Borrower uploaded documents
                </div>
                <div style={{ marginTop: "6px", fontSize: "13px" }}>
                  {Object.entries(supportingDocsByRequest).map(([key, docs]) => (
                    <div key={`${offer.id}-supporting-${key}`}>
                      <div style={{ fontWeight: 600 }}>{key}</div>
                      {docs.map((doc) => (
                        <a
                          key={doc.id}
                          href={doc.file_url}
                          target="_blank"
                          rel="noreferrer"
                          style={{ display: "block", color: "#0E5AA5" }}
                        >
                          {doc.file_name || "View document"}
                        </a>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="sl-loan-card-actions" style={{ margin: "10px 0px 0px 0px" }}>
          {renderAmendOfferButton({ loanType: "personal", offer: offer, onUpdated: () => setPersonalAcceptedOffers((prev) => prev.filter((entry) => entry.id !== offer.id)) })}
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              padding: "6px 0px",
              fontSize: "12px",
              margin: "0px",
              color: "white",
              width: "100%",
              marginTop: "10px",
              textAlign: "center",
              borderRadius: "30px",
              marginBottom: "10px",
              background: "rgba(214, 51, 132, 0.8)",
            }}
          >
            {statusLabel}
          </p>
          {!offer.disbursement_date ? (
            <button
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                openPersonalDisbursementModal(offer);
              }}
              disabled={!["awaiting_lender_documents", "pending_disbursement"].includes(offer.status)}
              className="all_button sl-card-primary-action sl-personal-primary-action"
              style={{
                background: "#d63384",
                color: "white",
                width: "100%",
                border: "none",
                borderRadius: "50px",
                padding: "6px 0px",
                fontSize: "12px",
                margin: "10px 0px 0px 0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              Set disbursement date
            </button>
          ) : (
            <button
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                openPersonalScheduleModal(offer);
              }}
              className="all_button sl-card-primary-action sl-personal-primary-action"
              style={{
                background: "#d63384",
                color: "white",
                width: "100%",
                border: "none",
                borderRadius: "50px",
                padding: "6px 0px",
                fontSize: "12px",
                margin: "10px 0px 0px 0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              Repayment schedule
            </button>
          )}
          <button
            className="all_button sl-card-secondary-action"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              if (!borrowerId) return;
              const url = `/l-messages?principelname=${borrowerName}&userid=${borrowerId}&requestamount=${offerData.amount || 0}`;
              history.push(url);
            }}
            style={{
              background: "transparent",
              color: "grey",
              width: "100%",
              border: "2px solid lightgrey",
              borderRadius: "15px",
              padding: "4px 20px",
              fontSize: "12px",
              marginTop: "10px",
            }}
          >
            Message borrower
          </button>
          {!offer.disbursement_date && (
            <p
              style={{
                fontSize: "11px",
                lineHeight: "1.4",
                color: "#555",
                marginTop: "10px",
                marginBottom: "0px",
                textAlign: "left",
              }}
            >
              Money Lenders are adviced to contact borrowers to set up the
              required appointment/site visit before setting the disbursement
              date which would prompt the loan to be accepted by both borrower
              and lender.
            </p>
          )}
        </div>
      </div>
    );
  };

  const PropertyOfferCard = ({ offer }) => {
    const offerData = offer.offer_data || {};
    const repaymentSchedules = offer.repayment_schedules || [];
    const remainingPeriod =
      repaymentSchedules.length > 0
        ? repaymentSchedules.filter((schedule) => !isRepaymentSettled(schedule))
            .length
        : null;
    const outstandingAmount =
      repaymentSchedules.length > 0
        ? repaymentSchedules
            .filter((schedule) => !isRepaymentSettled(schedule))
            .reduce(
              (total, schedule) => total + Number(schedule.amount_due || 0),
              0
            )
        : null;
    const borrowerName = getCompanyOfferBorrowerName(offer);
    const borrowerId =
      offer.borrower_summary?.user_id || offer.request?.user_id;
    const statusLabel =
      offer.status === "ongoing"
        ? "Ongoing"
        : offer.status === "awaiting_lender_documents"
        ? "Accepted"
        : offer.status?.replace(/_/g, " ") || "-";
    const requestLoanData = normalizePropertyLoanData(
      offer.request?.loan_data
    );

    return (
      <div
        className="sl-rebrand-loan-card sl-pending-loan-card sl-accepted-loan-card sl-property-loan-card"
        style={{
          width: "100%",
          textAlign: "center",
          borderRadius: "10px",
          backgroundColor: "#FFFFFFB3",
          border: "1px solid rgba(47, 158, 68, 0.35)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: screenWidth > 1200 ? "40vh" : "auto",
          padding: "15px",
          position: "relative",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "0px",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              role="button"
              tabIndex={0}
              aria-label={`View ${borrowerName}'s profile`}
              onClick={(event) => {
                event.stopPropagation();
                setSelectedBorrowerProfile({ loanType: "property", loan: { ...offer.request, borrower_summary: offer.borrower_summary }, borrowerName });
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  event.currentTarget.click();
                }
              }}
              className="sl-loan-avatar sl-loan-avatar-green"
              style={{
                cursor: "pointer",
                width: "55px",
                height: "55px",
                borderRadius: "50%",
                background: "#2f9e44",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                fontSize: 20,
                fontWeight: 600,
              }}
            >
              {borrowerName ? getInitials(borrowerName) : "SL"}
            </div>
            <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
              <h3
                style={{
                  fontWeight: "700",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "16px",
                  color: "#142C44CC",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                {borrowerName.length > 20
                  ? borrowerName.slice(0, 20) + "..."
                  : borrowerName}
              </h3>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(47, 158, 68, 0.7)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                {getPropertyLoanTypeLabel(requestLoanData)}
              </p>
            </div>
          </div>

          <div style={{ textAlign: "left", marginTop: "20px" }}>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Loan Amount
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {formatCurrency(offerData.amount)}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Outstanding Amount
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {outstandingAmount !== null
                ? formatCurrency(outstandingAmount)
                : "-"}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Disbursement Amount
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {formatCurrency(propertyLoanNetDisbursement(offerData.amount))}
            </p>
            <div className="sl-accepted-loan-processing-fee">
              <p className="sl-field-label">Processing fee</p>
              <p className="sl-field-value">
                {PROPERTY_LOAN_PROCESSING_FEE_LABEL} ({formatCurrency(propertyLoanProcessingFee(offerData.amount))})
              </p>
            </div>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Rate per month
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {offerData.rate_pa !== undefined
                ? `${offerData.rate_pa}% p.m.`
                : "-"}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Tenor
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {offerData.tenor_years
                ? `${offerData.tenor_years * 12} Months`
                : "-"}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Remaining Period
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "16px",
                color: "rgba(0,0,0,0.5)",
                textAlign: "left",
                margin: "0px 0px 10px 0px",
              }}
            >
              {remainingPeriod !== null ? `${remainingPeriod} Months` : "-"}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                textAlign: "left",
                margin: "0px",
              }}
            >
              Status
            </p>
            {offer.disbursement_date && (
              <>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                    textAlign: "left",
                    margin: "0px",
                    marginTop: "10px",
                  }}
                >
                  Disbursement Date
                </p>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "800",
                    fontSize: "16px",
                    color: "rgba(0,0,0,0.5)",
                    textAlign: "left",
                    margin: "0px 0px 10px 0px",
                  }}
                >
                  {formatDate(offer.disbursement_date)}
                </p>
              </>
            )}
          </div>
        </div>
        <div className="sl-loan-card-actions" style={{ margin: "10px 0px 0px 0px" }}>
          {renderAmendOfferButton({ loanType: "property", offer: offer, onUpdated: () => setPropertyAcceptedOffers((prev) => prev.filter((entry) => entry.id !== offer.id)) })}
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              padding: "6px 0px",
              fontSize: "12px",
              margin: "0px",
              color: "white",
              width: "100%",
              marginTop: "10px",
              textAlign: "center",
              borderRadius: "30px",
              marginBottom: "10px",
              background: "rgba(47, 158, 68, 0.8)",
            }}
          >
            {statusLabel}
          </p>
          {!offer.disbursement_date ? (
            <button
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                openPropertyDisbursementModal(offer);
              }}
              disabled={!["awaiting_lender_documents", "pending_disbursement"].includes(offer.status)}
              className="all_button sl-card-primary-action sl-property-primary-action"
              style={{
                background: "#2f9e44",
                color: "white",
                width: "100%",
                border: "none",
                borderRadius: "50px",
                padding: "6px 0px",
                fontSize: "12px",
                margin: "10px 0px 0px 0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              Set disbursement date
            </button>
          ) : (
            <button
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                openPropertyScheduleModal(offer);
              }}
              className="all_button sl-card-primary-action sl-property-primary-action"
              style={{
                background: "#2f9e44",
                color: "white",
                width: "100%",
                border: "none",
                borderRadius: "50px",
                padding: "6px 0px",
                fontSize: "12px",
                margin: "10px 0px 0px 0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              Repayment schedule
            </button>
          )}
          <button
            className="all_button sl-card-secondary-action"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              if (!borrowerId) return;
              const url = `/l-messages?principelname=${borrowerName}&userid=${borrowerId}&requestamount=${offerData.amount || 0}`;
              history.push(url);
            }}
            style={{
              background: "transparent",
              color: "grey",
              width: "100%",
              border: "2px solid lightgrey",
              borderRadius: "15px",
              padding: "4px 20px",
              fontSize: "12px",
              marginTop: "10px",
            }}
          >
            Message borrower
          </button>
        </div>
      </div>
    );
  };

  const handleUpload = async (loanId, borrowerId, lenderId) => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("image", file.originFileObj); // Use the original File instance
    });
    formData.append("loan_id", loanId.toString()); // Convert the loanId to string

    console.log("value form data", formData);

    const headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    try {
      const response = await fetch(
        `${API_BASE_URL}/loan/uploadPaymentReceipt`,
        {
          method: "POST",
          headers: headers,
          body: formData,
        }
      );

      if (response.status === 200) {
        try {
          let item = {
            user_id: borrowerId,
            channel: "system",
            subject: "Fund Transfer",
            message: `Lender ${lenderId} has made a fund transfer for the loan ${loanId}`,
          };
          const response = await fetch(
            `${API_BASE_URL}/user/notification/sendNotification`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify(item),
            }
          );
          const data = await response.json();
          console.log("File uploaded:", data);
        } catch (error) {
          console.error("Error uploading file:", error);
        }

        try {
          let item = {
            user_id: "A00001",
            channel: "system",
            subject: "Fund Transfer",
            message: `Lender ${lenderId} has made a fund transfer for the loan ${loanId}`,
          };
          const response = await fetch(
            `${API_BASE_URL}/user/notification/sendNotification`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify(item),
            }
          );
          const data = await response.json();
          console.log("File uploaded:", data);
        } catch (error) {
          console.error("Error uploading file:", error);
        }

        try {
          const response = await fetch(
            `${API_BASE_URL}/profile/createActivityLog?description=You had upload a fund transfer for the loan ${loanId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
            }
          );
          const data = await response.json();
          console.log("File uploaded:", data);
        } catch (error) {
          console.error("rror uploading file:", error);
        }
      } else if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log(data);
      setFileList([]);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // To redirect user if not authenticated
    const isAuthenticated = Cookies.get("token");
    const user_account_type = Cookies.get("user_account_type");

    if (!isAuthenticated) {
      history.push("/auth/signin");
    } else if (user_account_type === "borrower") {
      history.push("/b-dashboard");
    }
  }, [history]);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}/loan/viewAcceptedLoan`,
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        const parsedData = data["Accepted Loan"].map((item) => {
          const updatedItem = {
            ...item,
            credit_report_data: parseMaybeJson(item.credit_report_data) || {},
          };

          // Parse credit_report_data in loan_authorizations array
          const updatedLoanAuthorizations = item.loan_authorizations.map(
            (authorization) => ({
              ...authorization,
              credit_report_data:
                parseMaybeJson(authorization.credit_report_data) || {},
            })
          );

          // Update the item with the updated loan_authorizations array
          updatedItem.loan_authorizations = updatedLoanAuthorizations;

          return updatedItem;
        });
        setData(parsedData);
      } catch (error) {
        console.error(error);
      }
    }

    // call the fetchData function
    fetchData();
    async function fetchPersonalAcceptedOffers() {
      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      try {
        const response = await fetch(
          `${API_BASE_URL}/personalLoans/offers/accepted`,
          {
            method: "GET",
            headers,
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch personal loan offers");
        }

        const json = await response.json();
        setPersonalAcceptedOffers(json.data || []);
      } catch (error) {
        console.error(error);
      }
    }
    fetchPersonalAcceptedOffers();
    async function fetchPropertyAcceptedOffers() {
      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      try {
        const response = await fetch(
          `${API_BASE_URL}/propTermLoan/offers/accepted`,
          {
            method: "GET",
            headers,
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch property loan offers");
        }

        const json = await response.json();
        setPropertyAcceptedOffers(json.data || []);
      } catch (error) {
        console.error(error);
      }
    }
    fetchPropertyAcceptedOffers();
  }, []);

  const fetchLoanAgreement = async (loan_id, lender_id) => {
    console.log("fetching loan agreement");
    try {
      const response = await fetch(
        `${API_BASE_URL}/agreement/getAgreementDocument?loan_id=${loan_id}&lender_id=${lender_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      if (response.status === 200) {
        console.log("downloading Agreement");
        const blob = await response.blob();

        // Create an anchor element
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "Agreement.pdf"; // Set the desired filename here
        document.body.appendChild(a);

        // Trigger a click event on the anchor to start the download
        a.click();

        // Clean up the anchor element
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error("Error fetching loan agreement:", error);
    }
  };

  const fetchReceipt = async (loan_id, lender_id) => {
    console.log("fetching loan agreement");
    try {
      const response = await fetch(
        `${API_BASE_URL}/loan/viewPaymentReceipt?loan_id=${loan_id}&lender_id=${lender_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      if (response.status === 200) {
        console.log("downloading receipt");
        const blob = await response.blob();

        // Create an anchor element
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "receipt.pdf"; // Set the desired filename here
        document.body.appendChild(a);

        // Trigger a click event on the anchor to start the download
        a.click();

        // Clean up the anchor element
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error("Error fetching receipt:", error);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}/profile/viewActivityLog`,
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        const reversedData = data.reverse();

        setActivityLog(reversedData);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  const ContainerActivity = ({ title, subtitle, index }) => (
    <article className="sl-activity-event">
      <div
        className={`sl-activity-event-icon ${
          index === 1 ? "green" : index === 2 ? "" : "blue"
        }`}
      >
        {index === 1 ? "✓" : index === 2 ? "▧" : "↗"}
      </div>
      <div className="sl-activity-event-body">
        <div className="sl-activity-event-top">
          <h3>{title}</h3>
          <span>{index === 0 ? "Now" : index === 1 ? "Today" : "Recent"}</span>
        </div>
        <p>{subtitle}</p>
        <div className="sl-activity-event-meta">
          <span>{title ? getInitials(title) : "SL"}</span>
          <span>View activity</span>
        </div>
      </div>
    </article>
  );

  const ContainerLineChart = () => (
    <div className="sl-mini-chart-card sl-mini-chart-card-dark">
      <div className="sl-mini-chart-head">
        <div>
          <span>Net profit</span>
          <strong>4.0%</strong>
        </div>
        <em>+0.8%</em>
      </div>
      <div className="sl-mini-line">
        <svg viewBox="0 0 260 96" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="slAcceptedRailA" x1="0" x2="0" y1="0" y2="1">
              <stop stopColor="#8B6CFF" stopOpacity=".42" />
              <stop offset="1" stopColor="#8B6CFF" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path
            d="M6 68 C42 32 76 78 112 48 S184 22 254 36 L254 96 L6 96 Z"
            fill="url(#slAcceptedRailA)"
          />
          <path
            d="M6 68 C42 32 76 78 112 48 S184 22 254 36"
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M6 68 C42 32 76 78 112 48 S184 22 254 36"
            fill="none"
            stroke="#8B6CFF"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <p>Portfolio yield trend</p>
    </div>
  );

  const ContainerPieChart = () => (
    <div className="sl-mini-chart-card">
      <div className="sl-mini-chart-head">
        <div>
          <span>Forecast collection</span>
          <strong>$116,250</strong>
        </div>
      </div>
      <div className="sl-donut-chart">
        <svg viewBox="0 0 120 120" aria-hidden="true">
          <defs>
            <linearGradient id="slAcceptedDonutA" x1="0" x2="1">
              <stop stopColor="#7057F6" />
              <stop offset="1" stopColor="#285B9F" />
            </linearGradient>
          </defs>
          <circle
            cx="60"
            cy="60"
            r="48"
            fill="none"
            stroke="#EEF1FB"
            strokeWidth="16"
          />
          <circle
            cx="60"
            cy="60"
            r="48"
            fill="none"
            stroke="url(#slAcceptedDonutA)"
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray="182 302"
            transform="rotate(-90 60 60)"
          />
        </svg>
        <div>
          <strong>60%</strong>
          <span>collected</span>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [dppicture, setdppicture] = useState([]);

  const fillAllLenderPpicture = async (index, lenderId) => {
    // try {
    //   const response = await fetch(
    //     `https://www.smart-lend.com/api/user/getLenderPicture?lender_id=${lenderId}`,
    //     {
    //       method: "GET",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${Cookies.get("token")}`,
    //       },
    //     }
    //   );
    //   const blob = await response.blob();
    //   const imageUrl = URL.createObjectURL(blob);
    //   setdppicture((prevDppicture) => {
    //     const updatedDppicture = [...prevDppicture]; // Create a copy of the array
    //     updatedDppicture[index] = { profilepicture: imageUrl }; // Update the specific index
    //     console.log(updatedDppicture);
    //     return updatedDppicture;
    //   });
    // } catch (error) {
    //   console.error(error);
    // }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      data
        .slice(0, 6)
        .sort((a, b) => {
          if (sortBy === "loan-amount") {
            return a.offer_amount - b.offer_amount;
          } else if (sortBy === "date") {
            return new Date(a.created_at) - new Date(b.created_at);
          } else {
            // Default sorting option
            return new Date(b.created_at) - new Date(a.created_at);
          }
        })
        .map((item, index) => {
          console.log(item);
          fillAllLenderPpicture(index, item.borrower_id);
        });
    }
  }, [data, sortBy]);
  const [selectedBorrowerProfile, setSelectedBorrowerProfile] = useState(null);

  const getDocument = async () => {
    try {
      setDocumentIsLoading(true);
      const response = await fetch(
        `${API_BASE_URL}/documentModule/getDocument`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        for (const doc of data.document) {
          doc.document_data = JSON.parse(doc.document_data);
        }
        console.log(data.document);
        setDocuments(data.document);
        setDocumentIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      setDocumentIsLoading(false);
    }
  };


  const convertHtmlToPdfRenderer = (htmlString) => {
    if (!htmlString) return null;

    console.log(htmlString);

    const replacedHtmlString = replaceVariables(htmlString);

    const options = {
      replace: (domNode) => {
        const { name, children, attribs } = domNode;

        // Handle styling tags
        if (name === "strong") {
          return (
            <Text
              style={{
                fontFamily: "Poppins",
                fontWeight: "bold",
                fontSize: 8,
              }}
            >
              {domToReact(children, options)}{" "}
              {/* Process children for nested tags */}
            </Text>
          );
        } else if (name === "em" || name === "i") {
          return (
            <Text
              style={{
                fontFamily: "Poppins",
                fontStyle: "italic",
                fontSize: 8,
              }}
            >
              {domToReact(children, options)}{" "}
              {/* Process children for nested tags */}
            </Text>
          );
        } else if (name === "u") {
          return (
            <Text style={{ textDecoration: "underline", fontSize: 8 }}>
              {domToReact(children, options)}{" "}
              {/* Process children for nested tags */}
            </Text>
          );
        } else if (name === "s" || name === "strike") {
          return (
            <Text style={{ textDecoration: "line-through", fontSize: 8 }}>
              {domToReact(children, options)}{" "}
              {/* Process children for nested tags */}
            </Text>
          );
        }

        // Now handle structural tags
        if (name === "p") {
          return (
            <Text style={{ fontSize: 8 }}>
              {domToReact(children, options)}{" "}
              {/* Process children for nested tags */}
            </Text>
          );
        } else if (name === "br") {
          return <Text>{"\n"}</Text>;
        } else if (name === "ul" || name === "ol") {
          return (
            <View style={{ paddingLeft: 10, fontSize: 8 }}>
              {domToReact(children, options)}{" "}
              {/* Process children for nested tags */}
            </View>
          );
        } else if (name === "li") {
          // Handle indentation based on class name
          const indentClass = attribs?.class;
          let indentLevel = 0;

          if (indentClass && indentClass.startsWith("ql-indent-")) {
            const match = indentClass.match(/ql-indent-(\d+)/);
            if (match && match[1]) {
              indentLevel = parseInt(match[1], 10);
            }
          }

          return (
            <Text
              style={{
                marginBottom: 5,
                fontSize: 8,
                paddingLeft: 8 * indentLevel, // Adjust padding based on indent level
              }}
            >
              • {domToReact(children, options)}{" "}
              {/* Process children for nested tags */}
            </Text>
          );
        }

        // Handle Payment Schedule Table
        if (name === "div" && domNode.attribs?.class === "payment-schedule") {
          const schedule = typeOfDocumentVariables.loanAgreement.find(
            (v) => v.name === "Payment Schedule Table"
          ).sample;
          return <PaymentScheduleTable schedule={schedule} />;
        }

        // Handle any other tags if needed
        return null;
      },
    };

    // Parse the HTML string
    return parse(replacedHtmlString, options);
  };

  const PdfDocument = () => (
    <Document>
      <Page
        size="A4"
        style={{
          padding: 40,
          position: "relative",
          borderLeftWidth:
            documentSelected?.document_data?.headerTemplateId === 1 ? 10 : 0,
          borderLeftColor: documentSelected?.document_data?.docHighlightColor
            ? documentSelected?.document_data?.docHighlightColor
            : "rgb(14, 90, 165)",
        }}
      >
        <View>
          {documentSelected?.document_data?.headerTemplateId === 0 ? (
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingBottom: 20,
              }}
            >
              <View style={{ width: 100 }}>
                <Image
                  src={documentSelected.document_data?.logo}
                  style={{
                    height: 80,
                    width: 80,
                    objectFit: "contain",
                  }}
                />
              </View>
              <View>
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    fontSize: 14,
                  }}
                >
                  {documentSelected.document_data?.docCompanyName}
                </Text>
                <View style={{}}>
                  {documentSelected?.document_data?.headerDescriptionLines?.map(
                    (desc, index) =>
                      desc.text !== "" ? (
                        <Text
                          key={index}
                          style={{
                            fontSize: 8,
                            marginTop: 1,
                          }}
                        >
                          {desc.text}
                        </Text>
                      ) : null
                  )}
                </View>
                {documentSelected?.document_data?.headerDescriptionLines
                  ?.length > 0 &&
                documentSelected?.document_data?.headerSubDescriptionLines
                  ?.length > 0 ? (
                  <View
                    style={{
                      borderTopWidth: 1,
                      borderTopColor: "#dddddd",
                      marginTop: 10,
                      marginBottom: 10,
                    }}
                  />
                ) : null}
                <View
                  style={{ display: "flex", gap: "15px", flexDirection: "row" }}
                >
                  {documentSelected?.document_data?.headerSubDescriptionLines?.map(
                    (desc, index) =>
                      desc.text !== "" ? (
                        <Text
                          key={index}
                          style={{
                            fontSize: 8,
                          }}
                        >
                          {desc.text}
                        </Text>
                      ) : null
                  )}
                </View>
              </View>
            </View>
          ) : documentSelected?.document_data?.headerTemplateId === 1 ? (
            <View
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              {/* <View
                  style={{
                    width: "1.5vw",
                    background: documentSelected?.document_data
                      ?.docHighlightColor
                      ? documentSelected?.document_data
                          ?.docHighlightColor
                      : "rgb(14, 90, 165)",
                    position: "absolute",
                    top: "-4.5vw",
                    left: 0,
                  }}
                /> */}
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  paddingBottom: 20,
                }}
              >
                <View style={{ width: 300 }}>
                  <Image
                    src={documentSelected.document_data?.logo}
                    style={{
                      height: 80,
                      width: 80,
                      objectFit: "contain",
                    }}
                  />
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      fontSize: 14,
                    }}
                  >
                    {documentSelected.document_data?.docCompanyName}
                  </Text>
                  <View style={{}}>
                    {documentSelected?.document_data?.headerDescriptionLines?.map(
                      (desc, index) =>
                        desc.text !== "" ? (
                          <Text
                            key={index}
                            style={{
                              fontSize: 8,
                              marginTop: 1,
                            }}
                          >
                            {desc.text}
                          </Text>
                        ) : null
                    )}
                  </View>
                </View>
                <View
                  style={{
                    width: 300,
                  }}
                >
                  <View style={{}}>
                    {documentSelected?.document_data?.headerSubDescriptionLines?.map(
                      (desc, index) =>
                        desc.text !== "" ? (
                          <Text
                            key={index}
                            style={{
                              textAlign: "right",
                              fontSize: 8,
                              marginTop: 1,
                            }}
                          >
                            {desc.text}
                          </Text>
                        ) : null
                    )}
                  </View>
                </View>
              </View>
            </View>
          ) : null}

          <View
            style={{
              borderTopWidth: 1,
              borderTopColor: "#dddddd",
              marginBottom: 20,
            }}
          />
          {convertHtmlToPdfRenderer(documentSelected?.document_data?.content)}
        </View>
      </Page>
    </Document>
  );

  const acceptedLoanEntriesUnsearched = useMemo(() => {
    const corporateEntries = (data || []).map((loan) => ({
      type: "corporate",
      key: `corporate-${loan.loan_id}`,
      createdAt: loan.created_at,
      amount: Number(loan.amount || loan.offer_amount || 0),
      status: loan.status,
      loan,
    }));
    const personalEntries = (personalAcceptedOffers || []).map((offer) => ({
      type: "personal",
      key: `personal-${offer.id}`,
      createdAt: offer.created_at || offer.updated_at,
      amount: Number(offer.offer_data?.amount || 0),
      status: offer.status,
      offer,
    }));
    const propertyEntries = (propertyAcceptedOffers || []).map((offer) => ({
      type: "property",
      key: `property-${offer.id}`,
      createdAt: offer.created_at || offer.updated_at,
      amount: Number(offer.offer_data?.amount || 0),
      status: offer.status,
      offer,
    }));

    return [...corporateEntries, ...personalEntries, ...propertyEntries]
      .filter((entry) => {
        if (activeLoanTypeFilter === "personal") return entry.type === "personal";
        if (activeLoanTypeFilter === "corporate") {
          return entry.type === "corporate" || entry.type === "property";
        }
        if (activeLoanTypeFilter === "property") return entry.type === "property";
        return true;
      })
      .filter((entry) => {
        if (sortBy1 === "pending") return entry.status === "pending";
        if (sortBy1 === "ongoing") return entry.status === "ongoing";
        return true;
      })
      .sort((a, b) => {
        if (sortBy === "loan-amount") return a.amount - b.amount;
        return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
      });
  }, [
    activeLoanTypeFilter,
    data,
    personalAcceptedOffers,
    propertyAcceptedOffers,
    sortBy,
    sortBy1,
  ]);

  const acceptedLoanEntries = acceptedLoanEntriesUnsearched.filter((entry) => {
    const name = entry.type === "corporate"
      ? getCorporateLoanName(entry.loan)
      : entry.type === "personal"
      ? getPersonalOfferBorrowerName(entry.offer)
      : getCompanyOfferBorrowerName(entry.offer);
    return matchesLoanCardName(name, pageSearch);
  });

  const renderAcceptedLoanEntry = (entry, index) => {
    if (entry.type === "personal") {
      return <PersonalOfferCard key={entry.key} offer={entry.offer} />;
    }

    if (entry.type === "property") {
      return <PropertyOfferCard key={entry.key} offer={entry.offer} />;
    }

    const item = entry.loan;
    return (
      <Container
        key={entry.key}
        icon="https://cdn.pixabay.com/photo/2018/05/08/21/28/apple-3384010_960_720.png"
        title={getCorporateLoanName(item)}
        subtitle={item.express === 1 ? "Express Applicant" : "Approved Borrower"}
        label="Loan Amount"
        description={
          item.amount
            ? item.amount.toLocaleString("en-US", {
                style: "currency",
                currency: "SGD",
              })
            : "-"
        }
        label1={
          item.repayment_tenor === "" || item.repayment_tenor === null
            ? "Monthly Amount"
            : item.repayment_tenor === "Weekly"
            ? "Weekly Amount"
            : "Bi-Weekly Amount"
        }
        description1={(
          (item.amount * (item.interest_rate * item.period + 1)) /
          item.period
        ).toLocaleString("en-US", {
          style: "currency",
          currency: "SGD",
        })}
        label2="Period"
        description2={item.period + " Months"}
        label3="Loan Status"
        description3={
          item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : "-"
        }
        label4="Interest Rate Per Month"
        description4={(item.interest_rate * 100).toFixed(1) + " %"}
        createdAt={item.created_at}
        remainingPeriod={getCorporateRemainingPeriod(item)}
        outstandingAmount={getCorporateOutstandingAmount(item)}
        index={index}
        loanId={item.loan_id}
        borrowerId={item.borrower_id}
        lenderId={item.lender_id}
        borrowerNotSigned={item.borrower_sign}
        documentExist={item.document}
        previousDocumentExist={item.lender_sign}
        item={item}
      />
    );
  };

  return (
    <Box m="4px 20px 20px 20px" style={{ position: "relative" }}>
      {amendmentModal}
      <Modal
        width={isMobile ? "100%" : "90%"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={documentModalIsOpen}
        onCancel={() => {
          setDocumentModalIsOpen(false);
          setDocumentSelected(null);
          setActiveLoanId(null);
        }}
        footer={null}
      >
        {documentIsLoading ? (
          <div
            style={{
              padding: "200px 200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress color="primary" size={50} style={{}} />
          </div>
        ) : !documentSelected ? (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                marginBottom: "20px",
                color: "rgba(20, 44, 68, 0.8)",
                fontWeight: 900,
                fontFamily: "Manrope, sans-serif",
                fontSize: 20,
              }}
            >
              Select document to send
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {documents
                .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
                .filter(
                  (doc) =>
                    doc?.document_data?.typeOfDocument === "Loan Agreement"
                )
                .map((doc, index) => (
                  <div
                    className="border_change_hover"
                    onClick={(e) => {
                      e.preventDefault();
                      setDocumentSelected(doc);
                      findVariables(doc?.document_data?.content);
                    }}
                    style={{
                      padding: "20px",
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "120px",
                      height: "120px",
                      textAlign: "center",
                      border: "1px solid #1557a93A",
                      cursor: "pointer",
                    }}
                    key={index}
                  >
                    <div>
                      <FileCopyIcon
                        style={{ color: "#1557a94A", fontSize: "24px" }}
                      />
                    </div>
                    <div style={{ fontSize: "12px" }}>
                      {doc?.document_data?.documentName.length < 10
                        ? doc?.document_data?.documentName
                        : doc?.document_data?.documentName.slice(0, 10) +
                            "..." || "Unnamed"}
                    </div>
                    <div style={{ fontSize: "10px" }}>
                      {doc?.document_data?.typeOfDocument || "Others"}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "calc(100% - 20px)",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    color: "rgba(20, 44, 68, 0.8)",
                    fontWeight: 900,
                    fontFamily: "Manrope, sans-serif",
                    fontSize: 20,
                  }}
                >
                  Document Preview
                </div>
                <div
                  style={{ marginBottom: "20px", fonts: "12", color: "grey" }}
                >
                  Please Confirm the information to be used in the document is
                  correct
                </div>
              </div>
              <div>
                <div
                  className="mui_button"
                  onClick={async () => {
                    const blob = await pdf(<PdfDocument />).toBlob(); // Convert PDF to Blob
                    const file = new File([blob], "document.pdf", {
                      type: "application/pdf",
                    });

                    // Create a synthetic event to mimic file input change
                    const syntheticEvent = { target: { files: [file] } };

                    handleFileSelect(syntheticEvent, activeLoanId); // Pass it to the function
                    setDocumentModalIsOpen(false);
                    setDocumentSelected(null);
                    setActiveLoanId(null);
                  }}
                  style={{
                    background: "#1557a9",
                    color: "white",
                    width: "100%",
                    border: "none",
                    borderRadius: "50px",
                    padding: "6px 20px",
                    fontSize: "12px",
                    margin: "10px 0px 0px 0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  Confirm document
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
            >
              <div style={{ width: "25%", height: "70vh", overflowY: "auto" }}>
                {variablesUsed.map((sam, index) => (
                  <div key={index} style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 900,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 12,
                      }}
                    >
                      {sam.variableName}
                    </div>
                    <div>
                      <input
                        style={{
                          padding: "5px 8px",
                          borderRadius: "7px",
                          border: "1px solid lightgrey",
                          outline: "none",
                          width: "90%",
                        }}
                        value={sam.variableData}
                        onChange={(e) =>
                          handleVariableChange(sam.variableName, e.target.value)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ width: "75%" }}>
                <PDFViewer style={{ width: "100%", height: "70vh" }}>
                  <PdfDocument />
                </PDFViewer>
              </div>
            </div>
          </div>
        )}
      </Modal>
      {selectedBorrowerProfile && (
        <LenderBorrowerProfileModal
          key={`${selectedBorrowerProfile.loanType}-${selectedBorrowerProfile.loan.loan_id || selectedBorrowerProfile.loan.id}`}
          {...selectedBorrowerProfile}
          isMobile={isMobile}
          onClose={() => setSelectedBorrowerProfile(null)}
        />
      )}
      {fileUploading ? (
        <div
          style={{
            position: "fixed",
            background: "rgba(0,0,0,0.6)",
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            top: 0,
            left: 0,
          }}
        >
          Loading
        </div>
      ) : null}

	      <Modal
	        className="sl-loan-action-modal"
	        width={isMobile ? "100%" : "40vw"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={confirmAgreementModal}
        onCancel={() => {
          setConfirmAgreementModal(false);
          setSomethingWrong(false);
          setMessageForBorrower("");
        }}
        footer={
          dateForDisbursement
            ? [
                <React.Fragment key="footer-elements">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    {somethingWrong ? (
                      <>
                        <button
                          onClick={() => {
                            console.log(liveModalAgreementId);
                            amendAgreement();
                          }}
	                          className="all_button sl-modal-primary-action"
                          style={{
                            background: "#1557a9",
                            color: "white",
                            border: "none",
                            borderRadius: "50px",
                            padding: "6px 0px",
                            fontSize: "12px",
                            margin: "10px 5px 0px 0px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "180px",
                          }}
                        >
                          Send
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            console.log(liveModalAgreementId);
                            agreeToAgreement();
                          }}
	                          className="all_button sl-modal-primary-action"
                          style={{
                            background: "#1557a9",
                            color: "white",
                            border: "none",
                            borderRadius: "50px",
                            padding: "6px 0px",
                            fontSize: "12px",
                            margin: "10px 5px 0px 0px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "180px",
                          }}
                        >
                          Agree
                        </button>
                        <button
                          onClick={() => {
                            setConfirmAgreementModal(false);
                            setSomethingWrong(false);
                            setMessageForBorrower("");
                          }}
	                          className="all_button sl-card-secondary-action"
                          style={{
                            background: "transparent",
                            color: "grey",
                            border: "2px solid lightgrey",
                            borderRadius: "50px",
                            padding: "4px 0px",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "10px 0px 0px 0px",
                            cursor: "pointer",
                            width: "180px",
                          }}
                        >
                          Cancel
                        </button>
                      </>
                    )}
                  </div>
                </React.Fragment>,
              ]
            : null
        }
	      >
	        <div className="sl-loan-modal-head">
	          <div className="sl-loan-modal-title">
	            <div className="sl-loan-modal-mark">CL</div>
	            <div>
	              <h2>Approve Disbursement</h2>
	              <p>Confirm the fund disbursement details for this corporate loan.</p>
	            </div>
	          </div>
	        </div>
	        <div
	          className="sl-loan-modal-panel sl-accepted-date-panel"
	          style={{
	            display: "flex",
            flexDirection: "row",
            marginTop: 16,
            borderRadius: "10px",
            textAlign: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          {somethingWrong ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: "10px",
                textAlign: "center",
                width: "70%",
                justifyContent: "center",
                fontSize: "14px",
              }}
            >
              Please leave a note to the borrower to tell them what is wrong
              with the agreement, leave clear instructions to ensure that
              borrower can ammend accordingly.
              <textarea
                value={messageForBorrower}
                onChange={(e) => setMessageForBorrower(e.target.value)}
                style={{
                  width: "100%",
                  height: "100px",
                  outline: "none",
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  resize: "none",
                  textAlign: "center",
                  marginTop: "10px",
                  fontSize: "11px",
                }}
              />
            </div>
          ) : (
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderRadius: "10px",
                  textAlign: "center",
                  width: "70%",
                  marginLeft: "15%",
                  justifyContent: "center",
                  fontSize: "14px",
                }}
              >
                Please specify the date of fund disbursement for the selected
                loan.
              </div>
              <div style={{ marginTop: "15px" }}>
                <input
                  type="date"
                  value={dateForDisbursement}
                  onChange={(e) => {
                    console.log(e.target.value);
                    setDateForDisbursement(e.target.value);
                  }}
                  style={{
                    border: "1px solid lightgrey",
                    padding: "4px 20px",
                    borderRadius: "8px",
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </Modal>
	      <Modal
	        className="sl-loan-action-modal sl-personal-loan-modal"
	        width={isMobile ? "100%" : "40vw"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={personalDisbursementModal}
        onCancel={closePersonalDisbursementModal}
        footer={
          personalDisbursementDate
            ? [
                <div
                  key="personal-disbursement-footer"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <button
                    onClick={submitPersonalDisbursementDate}
	                    className="all_button sl-modal-primary-action sl-personal-modal-primary-action"
                    disabled={personalDisbursementBusy}
                    style={{
                      background: "#d63384",
                      color: "white",
                      border: "none",
                      borderRadius: "50px",
                      padding: "6px 0px",
                      fontSize: "12px",
                      margin: "10px 5px 0px 0px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "180px",
                      opacity: personalDisbursementBusy ? 0.7 : 1,
                    }}
                  >
                    {personalDisbursementBusy ? "Saving..." : "Confirm"}
                  </button>
                  <button
                    onClick={closePersonalDisbursementModal}
	                    className="all_button sl-card-secondary-action"
                    style={{
                      background: "transparent",
                      color: "grey",
                      border: "2px solid lightgrey",
                      borderRadius: "50px",
                      padding: "4px 0px",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "10px 0px 0px 0px",
                      cursor: "pointer",
                      width: "180px",
                    }}
                  >
                    Cancel
                  </button>
                </div>,
              ]
            : null
        }
	      >
	        <div className="sl-loan-modal-head">
	          <div className="sl-loan-modal-title">
	            <div className="sl-loan-modal-mark pink">ML</div>
	            <div>
	              <h2>Set Disbursement Date</h2>
	              <p>Confirm the disbursement date for this money lender loan.</p>
	            </div>
	          </div>
	        </div>
	        <div
	          className="sl-loan-modal-panel sl-accepted-date-panel"
	          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 16,
            borderRadius: "10px",
            textAlign: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                borderRadius: "10px",
                textAlign: "center",
                width: "70%",
                marginLeft: "15%",
                justifyContent: "center",
                fontSize: "14px",
              }}
            >
              Please specify the date of fund disbursement for the selected
              personal loan.
            </div>
            <div style={{ marginTop: "15px" }}>
              <input
                type="date"
                value={personalDisbursementDate}
                onChange={(e) => setPersonalDisbursementDate(e.target.value)}
                style={{
                  border: "1px solid lightgrey",
                  padding: "4px 20px",
                  borderRadius: "8px",
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
	      <Modal
	        className="sl-loan-action-modal sl-property-loan-modal"
	        width={isMobile ? "100%" : "50vw"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={propertyDisbursementModal}
        onCancel={closePropertyDisbursementModal}
        footer={
          propertyDisbursementDate
            ? [
                <div
                  key="property-disbursement-footer"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <button
                    onClick={submitPropertyDisbursementDate}
	                    className="all_button sl-modal-primary-action sl-property-modal-primary-action"
                    disabled={propertyDisbursementBusy}
                    style={{
                      background: "#2f9e44",
                      color: "white",
                      border: "none",
                      borderRadius: "50px",
                      padding: "6px 0px",
                      fontSize: "12px",
                      margin: "10px 5px 0px 0px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "180px",
                      opacity: propertyDisbursementBusy ? 0.7 : 1,
                    }}
                  >
                    {propertyDisbursementBusy ? "Saving..." : "Confirm"}
                  </button>
                  <button
                    onClick={closePropertyDisbursementModal}
	                    className="all_button sl-card-secondary-action"
                    style={{
                      background: "transparent",
                      color: "grey",
                      border: "2px solid lightgrey",
                      borderRadius: "50px",
                      padding: "4px 0px",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "10px 0px 0px 0px",
                      cursor: "pointer",
                      width: "180px",
                    }}
                  >
                    Cancel
                  </button>
                </div>,
              ]
            : null
        }
	      >
	        <div className="sl-loan-modal-head">
	          <div className="sl-loan-modal-title">
	            <div className="sl-loan-modal-mark green">PL</div>
	            <div>
	              <h2>Set Disbursement Date</h2>
	              <p>Confirm the disbursement date and preview the repayment plan.</p>
	            </div>
	          </div>
	        </div>
	        <div
	          className="sl-loan-modal-panel sl-accepted-date-panel"
	          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 16,
            borderRadius: "10px",
            textAlign: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                borderRadius: "10px",
                textAlign: "center",
                width: "70%",
                marginLeft: "15%",
                justifyContent: "center",
                fontSize: "14px",
              }}
            >
              Please specify the date of fund disbursement for the selected
              property term loan. The first installment will be due on the same
              day next month.
            </div>
            <div style={{ marginTop: "15px" }}>
              <input
                type="date"
                value={propertyDisbursementDate}
                onChange={(e) => setPropertyDisbursementDate(e.target.value)}
                style={{
                  border: "1px solid lightgrey",
                  padding: "4px 20px",
                  borderRadius: "8px",
                }}
              />
            </div>
          </div>
        </div>
        {propertyDisbursementOffer && propertyDisbursementDate && (
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: "13px",
                marginBottom: "10px",
                color: "#142C44CC",
                textAlign: "left",
              }}
            >
              Installment preview
            </div>
            <div style={{ maxHeight: "40vh", overflowY: "auto" }}>
              {buildPropertyPreviewSchedule(
                propertyDisbursementOffer,
                propertyDisbursementDate
              ).map((entry, index) => (
                <div
                  key={`${entry.due_date}-${index}`}
                  style={{
                    border: "1px solid rgba(0,0,0,0.1)",
                    borderRadius: "10px",
                    padding: "10px",
                    marginBottom: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  <div>Installment {index + 1}</div>
                  <div>{formatDate(entry.due_date)}</div>
                  <div style={{ fontWeight: 600 }}>
                    {formatCurrency(entry.amount_due)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal>
	      <Modal
	        className="sl-loan-action-modal"
	        width={isMobile ? "100%" : "50vw"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={corporateScheduleModal}
        onCancel={closeCorporateScheduleModal}
        footer={[
          <div
            key="corporate-schedule-footer"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              onClick={closeCorporateScheduleModal}
	              className="all_button sl-card-secondary-action"
              style={{
                background: "transparent",
                color: "grey",
                border: "2px solid lightgrey",
                borderRadius: "50px",
                padding: "4px 0px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "10px 0px 0px 0px",
                cursor: "pointer",
                width: "180px",
              }}
            >
              Close
            </button>
          </div>,
        ]}
      >
	        <div className="sl-loan-modal-head">
	          <div className="sl-loan-modal-title">
	            <div className="sl-loan-modal-mark">CL</div>
	            <div>
	              <h2>Repayment Schedule</h2>
	              <p>Track and validate corporate loan repayments.</p>
	            </div>
	          </div>
	        </div>
	        <div className="sl-accepted-schedule-list">
          {(corporateScheduleLoan?.repayments || []).length > 0 ? (
            (corporateScheduleLoan?.repayments || [])
              .slice()
              .sort(
                (a, b) =>
                  new Date(a.repay_due_date) - new Date(b.repay_due_date)
              )
              .map((repayment, index) => {
                const isPaid = isRepaymentSettled(repayment);
                const isConfirmedPaid = getRepaymentStatus(repayment) === "paid";
                const amountDue =
                  repayment.repay_total_amount ?? repayment.repay_amount;
                return (
	                  <div
	                    className="sl-accepted-schedule-row"
	                    key={repayment.repay_id || repayment.id || index}
                    style={{
                      border: "1px solid rgba(0,0,0,0.1)",
                      borderRadius: "10px",
                      padding: "12px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <div style={{ fontWeight: 700, fontSize: "13px" }}>
                          Installment {index + 1}
                        </div>
                        <div
                          style={{ fontSize: "12px", color: "rgba(0,0,0,0.55)" }}
                        >
                          Due {formatDate(repayment.repay_due_date)}
                        </div>
                      </div>
                      <div
                        style={{
                          background: isPaid
                            ? "rgba(19,159,42,0.15)"
                            : "rgba(231,208,17,0.2)",
                          color: isPaid ? "#139F2ACC" : "#9C8A00",
                          fontSize: "11px",
                          fontWeight: 600,
                          padding: "4px 10px",
                          borderRadius: "20px",
                        }}
                      >
                        {repaymentStatusLabel(repayment)}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "8px",
                        fontSize: "13px",
                      }}
                    >
                      <div>Amount</div>
                      <div style={{ fontWeight: 600 }}>
                        {formatCurrency(amountDue)}
                      </div>
                    </div>
                    <button
                      disabled={corporateScheduleBusy || isConfirmedPaid}
                      onClick={() => toggleCorporateRepaymentStatus(repayment)}
	                      className="all_button sl-card-secondary-action"
                      style={{
                        background: "transparent",
                        color: "grey",
                        width: "100%",
                        border: "2px solid lightgrey",
                        borderRadius: "15px",
                        padding: "4px 20px",
                        fontSize: "12px",
                        marginTop: "10px",
                        opacity:
                          corporateScheduleBusy || isConfirmedPaid ? 0.7 : 1,
                        cursor: corporateScheduleBusy || isConfirmedPaid
                          ? "not-allowed"
                          : "pointer",
                      }}
                    >
                      {isConfirmedPaid ? "Received" : "Confirm received"}
                    </button>
                  </div>
                );
              })
          ) : (
            <div
              style={{
                width: "100%",
                padding: "20px",
                background: "rgba(255,255,255,0.7)",
                borderRadius: "10px",
                height: "120px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "Manrope, sans-serif",
                fontSize: "0.8em",
                fontWeight: "600",
                color: "#00000066",
              }}
            >
              No repayment schedule available.
            </div>
          )}
        </div>
      </Modal>
	      <Modal
	        className="sl-loan-action-modal sl-personal-loan-modal"
	        width={isMobile ? "100%" : "50vw"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={personalScheduleModal}
        onCancel={closePersonalScheduleModal}
        footer={[
          <div
            key="schedule-footer"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              onClick={closePersonalScheduleModal}
	              className="all_button sl-card-secondary-action"
              style={{
                background: "transparent",
                color: "grey",
                border: "2px solid lightgrey",
                borderRadius: "50px",
                padding: "4px 0px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "10px 0px 0px 0px",
                cursor: "pointer",
                width: "180px",
              }}
            >
              Close
            </button>
          </div>,
        ]}
      >
	        <div className="sl-loan-modal-head">
	          <div className="sl-loan-modal-title">
	            <div className="sl-loan-modal-mark pink">ML</div>
	            <div>
	              <h2>Repayment Schedule</h2>
	              <p>Track repayment status for this money lender loan.</p>
	            </div>
	          </div>
	        </div>
	        <div className="sl-accepted-schedule-list">
          {(personalScheduleOffer?.repayment_schedules || []).length > 0 ? (
            (personalScheduleOffer?.repayment_schedules || []).map(
              (repayment, index) => (
	                <div
	                  className="sl-accepted-schedule-row"
	                  key={repayment.id || index}
                  style={{
                    border: "1px solid rgba(0,0,0,0.1)",
                    borderRadius: "10px",
                    padding: "12px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <div
                        style={{ fontWeight: 700, fontSize: "13px" }}
                      >
                        Installment {index + 1}
                      </div>
                      <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.55)" }}>
                        Due {formatDate(repayment.due_date)}
                      </div>
                    </div>
                    <div
                      style={{
                        background:
                          isRepaymentSettled(repayment)
                            ? "rgba(19,159,42,0.15)"
                            : "rgba(231,208,17,0.2)",
                        color:
                          isRepaymentSettled(repayment)
                            ? "#139F2ACC"
                            : "#9C8A00",
                        fontSize: "11px",
                        fontWeight: 600,
                        padding: "4px 10px",
                        borderRadius: "20px",
                      }}
                    >
                      {repaymentStatusLabel(repayment)}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      fontSize: "13px",
                    }}
                  >
                    <div>Amount</div>
                    <div style={{ fontWeight: 600 }}>
                      {formatCurrency(repayment.amount_due)}
                    </div>
                  </div>
                  <button
                    disabled={personalScheduleBusy}
                    onClick={() => togglePersonalRepaymentStatus(repayment)}
	                    className="all_button sl-card-secondary-action"
                    style={{
                      background: "transparent",
                      color: "grey",
                      width: "100%",
                      border: "2px solid lightgrey",
                      borderRadius: "15px",
                      padding: "4px 20px",
                      fontSize: "12px",
                      marginTop: "10px",
                      opacity: personalScheduleBusy ? 0.7 : 1,
                      cursor: personalScheduleBusy ? "not-allowed" : "pointer",
                    }}
                  >
                    {repayment.status === "paid"
                      ? "Clear payment confirmation"
                      : "Mark as paid"}
                  </button>
                </div>
              )
            )
          ) : (
            <div
              style={{
                width: "100%",
                padding: "20px",
                background: "rgba(255,255,255,0.7)",
                borderRadius: "10px",
                height: "120px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "Manrope, sans-serif",
                fontSize: "0.8em",
                fontWeight: "600",
                color: "#00000066",
              }}
            >
              No repayment schedule available.
            </div>
          )}
        </div>
      </Modal>
	      <Modal
	        className="sl-loan-action-modal sl-property-loan-modal"
	        width={isMobile ? "100%" : "50vw"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={propertyScheduleModal}
        onCancel={closePropertyScheduleModal}
        footer={[
          <div
            key="property-schedule-footer"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              onClick={closePropertyScheduleModal}
	              className="all_button sl-card-secondary-action"
              style={{
                background: "transparent",
                color: "grey",
                border: "2px solid lightgrey",
                borderRadius: "50px",
                padding: "4px 0px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "10px 0px 0px 0px",
                cursor: "pointer",
                width: "180px",
              }}
            >
              Close
            </button>
          </div>,
        ]}
      >
	        <div className="sl-loan-modal-head">
	          <div className="sl-loan-modal-title">
	            <div className="sl-loan-modal-mark green">PL</div>
	            <div>
	              <h2>Repayment Schedule</h2>
	              <p>Track repayment status for this property term loan.</p>
	            </div>
	          </div>
	        </div>
	        <div className="sl-accepted-schedule-list">
          {(propertyScheduleOffer?.repayment_schedules || []).length > 0 ? (
            (propertyScheduleOffer?.repayment_schedules || []).map(
              (repayment, index) => (
	                <div
	                  className="sl-accepted-schedule-row"
	                  key={repayment.id || index}
                  style={{
                    border: "1px solid rgba(0,0,0,0.1)",
                    borderRadius: "10px",
                    padding: "12px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <div style={{ fontWeight: 700, fontSize: "13px" }}>
                        Installment {index + 1}
                      </div>
                      <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.55)" }}>
                        Due {formatDate(repayment.due_date)}
                      </div>
                    </div>
                    <div
                      style={{
                        background:
                          isRepaymentSettled(repayment)
                            ? "rgba(19,159,42,0.15)"
                            : "rgba(231,208,17,0.2)",
                        color:
                          isRepaymentSettled(repayment)
                            ? "#139F2ACC"
                            : "#9C8A00",
                        fontSize: "11px",
                        fontWeight: 600,
                        padding: "4px 10px",
                        borderRadius: "20px",
                      }}
                    >
                      {repaymentStatusLabel(repayment)}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      fontSize: "13px",
                    }}
                  >
                    <div>Amount</div>
                    <div style={{ fontWeight: 600 }}>
                      {formatCurrency(repayment.amount_due)}
                    </div>
                  </div>
                  <button
                    disabled={propertyScheduleBusy}
                    onClick={() => togglePropertyRepaymentStatus(repayment)}
	                    className="all_button sl-card-secondary-action"
                    style={{
                      background: "transparent",
                      color: "grey",
                      width: "100%",
                      border: "2px solid lightgrey",
                      borderRadius: "15px",
                      padding: "4px 20px",
                      fontSize: "12px",
                      marginTop: "10px",
                      opacity: propertyScheduleBusy ? 0.7 : 1,
                      cursor: propertyScheduleBusy ? "not-allowed" : "pointer",
                    }}
                  >
                    {repayment.status === "paid"
                      ? "Clear payment confirmation"
                      : "Mark as paid"}
                  </button>
                </div>
              )
            )
          ) : (
            <div
              style={{
                width: "100%",
                padding: "20px",
                background: "rgba(255,255,255,0.7)",
                borderRadius: "10px",
                height: "120px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "Manrope, sans-serif",
                fontSize: "0.8em",
                fontWeight: "600",
                color: "#00000066",
              }}
            >
              No repayment schedule available.
            </div>
          )}
        </div>
      </Modal>

      <Box
        className="sl-loan-request-page"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
      >
        <Box
          className="sl-loan-request-main"
          gridColumn={isMobile ? "span 12" : "span 9"}
          gridRow="span 2"
          borderRadius="10px"
          opacity="0.95"
          paddingBottom="100px"
          style={{
            overflowY: "scroll",
            height: isMobile ? "80vh" : "90vh",
            overflowX: "hidden",
            background:
              "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
            padding: "15px 15px 50px 15px",
          }}
        >
          <Box gridColumn="span 4" gridRow="span 2" opacity="0.95">
	            <Box
	              className="sl-loan-request-head"
	              display="flex"
              alignItems="center"
              justifyContent="space-between"
              style={{ width: "100%" }}
              borderRadius="10px"
            >
              <Typography
                color={colors.grey[920]}
                variant="h5"
                fontWeight="800"
                fontFamily="Manrope, sans-serif"
                fontSize="18px"
              >
                Accepted Loans
              </Typography>
              <div className="sl-loan-type-filter" aria-label="Loan type filter">
                {[
                  ["all", "All", "#0F172A"],
	                  ["corporate", "Corporate", "#7057F6"],
	                  ["personal", "Personal", "#EC4899"],
	                  ["property", "Property", "rgb(47, 158, 68)"],
	                  ["concierge", "Concierge", "#A855F7"],
                ].map(([value, label, color]) => (
                  <button
                    key={value}
                    type="button"
                    className={activeLoanTypeFilter === value ? "is-active" : ""}
                    onClick={() => setActiveLoanTypeFilter(value)}
                  >
                    {value !== "all" ? (
                      <span className="dot" style={{ background: color }} />
                    ) : null}
                    {label}
                    <span className="count">{loanTypeCounts[value]}</span>
                  </button>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  flexDirection: isMobile ? "row-reverse" : "row",
                  width: isMobile ? "auto" : "400px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <label
                    htmlFor="sort-by"
                    style={{
                      marginRight: "7px",
                      marginLeft: "10px",
                      color: "#142C44CC",
                      fontWeight: "800",
                      fontSize: "13px",
                      fontFamily: "Manrope, sans-serif",
                      display: isMobile ? "none" : "block",
                    }}
                  >
                    View:
                  </label>
                  <div style={{ width: isMobile ? "90%" : "60%" }}>
                    <select
                      id="sort-by"
                      value={sortBy1}
                      onChange={(e) => setSortBy1(e.target.value)}
                      style={{
                        width: "100%",
                        borderRadius: "30px",
                        color: "#0E5AA5",
                        backgroundColor: "#ECF0F5",
                        border: "1px solid #3E536733",
                        fontWeight: "600",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "13px",
                      }}
                    >
                      <option value="all">All Loans</option>
                      <option value="pending">Pending Loans</option>
                      <option value="ongoing">Ongoing Loans</option>
                    </select>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <label
                    htmlFor="sort-by"
                    style={{
                      marginRight: "7px",
                      marginLeft: "10px",
                      color: "#142C44CC",
                      fontWeight: "800",
                      fontSize: "13px",
                      fontFamily: "Manrope, sans-serif",
                    }}
                  >
                    Sort by:
                  </label>
                  <div style={{ width: "60%" }}>
                    <select
                      id="sort-by"
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                      style={{
                        width: "100%",
                        borderRadius: "30px",
                        color: "#0E5AA5",
                        backgroundColor: "#ECF0F5",
                        border: "1px solid #3E536733",
                        fontWeight: "600",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "13px",
                      }}
                    >
                      <option value="default">Date & Time</option>
                      <option value="loan-amount">Loan Amount</option>
                    </select>
                  </div>
                </div>
              </div>
            </Box>
            <Box gridColumn="span 4">
              <div className="sl-loan-grid-list">
                {acceptedLoanEntries.length > 0 ? (
                  acceptedLoanEntries.map((entry, index) =>
                    renderAcceptedLoanEntry(entry, index)
                  )
                ) : (
                  <div
                    style={{
                      width: "100%",
                      padding: "0px 15px",
                      background: "rgba(255,255,255,0.7)",
                      borderRadius: "10px",
                      height: "150px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontFamily: "Manrope, sans-serif",
                      fontSize: "0.8em",
                      fontWeight: "600",
                      color: "#00000066",
                    }}
                  >
                    {pageSearch.trim() ? "No results found" : "No loans accepted"}
                  </div>
                )}
              </div>
            </Box>
          </Box>
        </Box>
	        {!isMobile ? (
	          <Box
	            className="sl-loan-filter-panel sl-dashboard-rail"
	            gridColumn="span 3"
            gridRow="span 2"
            // backgroundColor="rgba(153, 178, 205, 0)"
            overflow="auto"
            height="90vh"
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              style={{ marginBottom: "10px" }}
            >
	              <Typography
	                className="sl-dashboard-section-title"
	                color={colors.grey[920]}
                variant="h5"
                fontWeight="800"
                fontFamily="Manrope, sans-serif"
                fontSize="18px"
              >
                Analytics
              </Typography>
            </Box>
	            <Box
	              className="sl-dashboard-analytics"
	              gridColumn="span 2"
              opacity="1.00"
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="200px"
	              marginBottom="-2.5vh"
            >
              <Box
                width="49%"
                opacity="1.00"
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="170px"
              >
                <ContainerLineChart></ContainerLineChart>
              </Box>
              {/* <Box
                width="49%"
                opacity="1.00"
                display="flex"
                alignItems="left"
                justifyContent="left"
                height="200px"
                marginLeft="10px"
              >
                <ContainerPieChart></ContainerPieChart>
              </Box> */}
            </Box>
            <Box
              gridColumn="span 4"
              gridRow="span 2"
              backgroundColor="rgba(153, 178, 205, 0)"
              overflow="auto"
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                style={{ marginBottom: "10px" }}
              >
	                <Typography
	                  className="sl-dashboard-section-title"
	                  color={colors.grey[920]}
                  variant="h5"
                  fontWeight="800"
                  fontFamily="Manrope, sans-serif"
	                  fontSize="20px"
                >
                  Activity Log
                </Typography>
              </Box>
	              {dataActivityLog && dataActivityLog.length > 0 ? (
	                <div className="sl-activity-log">
	                {dataActivityLog.slice(0, 3).map((item, index) => (
	                  <Box
	                    key={index}
	                    gridColumn="span 1"
                    // backgroundColor={colors.grey[910]}
                    display="flex"
                    alignItems="left"
                    justifyContent="left"
                    style={{
	                      opacity:
	                        index === 2
	                          ? 0.6
	                          : index === 3
	                          ? 0.2
	                          : index === 1
	                          ? 0.9
	                          : 1,
                      transitionDelay: `${index * 0.1}s`,
                    }}
                  >
                    <ContainerActivity
	                      title={item.principal_name || "-"}
                      subtitle={item.description || "-"}
                      index={index}
	                    />
	                  </Box>
	                ))}
	                </div>
	              ) : (
                <div
                  style={{
                    width: "100%",
                    padding: "0px 0px",
                    marginTop: "15px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      padding: "0px 15px",
                      background: "rgba(255,255,255,0.7)",
                      borderRadius: "10px",
                      height: "48vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontFamily: "Manrope, sans-serif",
                      fontSize: "0.8em",
                      fontWeight: "600",
                      color: "#00000066",
                    }}
                  >
                    No Activity Log
                  </div>
                </div>
              )}
            </Box>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default AcceptedLoans;
